/**
 * Comprehensive Food Database
 * All nutritional values are per 100g for accurate gram-based calculations
 * Expanded with Peruvian foods based on Tablas Peruanas de Composición de Alimentos (INS)
 */

export const foodDatabase = [
  // FRUITS
  {
    id: 'fruit-1',
    name: 'Manzana',
    category: 'Frutas',
    calories: 52,
    protein: 0.3,
    carbs: 14,
    fat: 0.2,
    fiber: 2.4,
    defaultServing: 182,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'fruit-2',
    name: 'Plátano',
    category: 'Frutas',
    calories: 89,
    protein: 1.1,
    carbs: 23,
    fat: 0.3,
    fiber: 2.6,
    defaultServing: 118,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'fruit-3',
    name: 'Naranja',
    category: 'Frutas',
    calories: 47,
    protein: 0.9,
    carbs: 12,
    fat: 0.1,
    fiber: 2.4,
    defaultServing: 131,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'fruit-4',
    name: 'Fresa',
    category: 'Frutas',
    calories: 32,
    protein: 0.7,
    carbs: 8,
    fat: 0.3,
    fiber: 2,
    defaultServing: 150,
    servingUnit: 'taza'
  },
  {
    id: 'fruit-5',
    name: 'Sandía',
    category: 'Frutas',
    calories: 30,
    protein: 0.6,
    carbs: 8,
    fat: 0.2,
    fiber: 0.4,
    defaultServing: 280,
    servingUnit: 'rodaja'
  },
  {
    id: 'fruit-6',
    name: 'Uvas',
    category: 'Frutas',
    calories: 69,
    protein: 0.7,
    carbs: 18,
    fat: 0.2,
    fiber: 0.9,
    defaultServing: 150,
    servingUnit: 'taza'
  },
  {
    id: 'fruit-7',
    name: 'Mango',
    category: 'Frutas',
    calories: 60,
    protein: 0.8,
    carbs: 15,
    fat: 0.4,
    fiber: 1.6,
    defaultServing: 165,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'fruit-8',
    name: 'Piña',
    category: 'Frutas',
    calories: 50,
    protein: 0.5,
    carbs: 13,
    fat: 0.1,
    fiber: 1.4,
    defaultServing: 165,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'fruit-9',
    name: 'Pera',
    category: 'Frutas',
    calories: 57,
    protein: 0.4,
    carbs: 15,
    fat: 0.1,
    fiber: 3.1,
    defaultServing: 178,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'fruit-10',
    name: 'Kiwi',
    category: 'Frutas',
    calories: 61,
    protein: 1.1,
    carbs: 15,
    fat: 0.5,
    fiber: 3,
    defaultServing: 69,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'fruit-11',
    name: 'Papaya',
    category: 'Frutas',
    calories: 43,
    protein: 0.5,
    carbs: 11,
    fat: 0.3,
    fiber: 1.7,
    defaultServing: 140,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'fruit-12',
    name: 'Melón',
    category: 'Frutas',
    calories: 34,
    protein: 0.8,
    carbs: 8,
    fat: 0.2,
    fiber: 0.9,
    defaultServing: 160,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'fruit-13',
    name: 'Durazno',
    category: 'Frutas',
    calories: 39,
    protein: 0.9,
    carbs: 10,
    fat: 0.3,
    fiber: 1.5,
    defaultServing: 150,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'fruit-14',
    name: 'Ciruela',
    category: 'Frutas',
    calories: 46,
    protein: 0.7,
    carbs: 11,
    fat: 0.3,
    fiber: 1.4,
    defaultServing: 66,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'fruit-15',
    name: 'Arándanos',
    category: 'Frutas',
    calories: 57,
    protein: 0.7,
    carbs: 14,
    fat: 0.3,
    fiber: 2.4,
    defaultServing: 148,
    servingUnit: 'taza'
  },
  {
    id: 'fruit-16',
    name: 'Frambuesas',
    category: 'Frutas',
    calories: 52,
    protein: 1.2,
    carbs: 12,
    fat: 0.7,
    fiber: 6.5,
    defaultServing: 123,
    servingUnit: 'taza'
  },
  {
    id: 'fruit-17',
    name: 'Moras',
    category: 'Frutas',
    calories: 43,
    protein: 1.4,
    carbs: 10,
    fat: 0.5,
    fiber: 5.3,
    defaultServing: 144,
    servingUnit: 'taza'
  },
  {
    id: 'fruit-18',
    name: 'Cereza',
    category: 'Frutas',
    calories: 63,
    protein: 1.1,
    carbs: 16,
    fat: 0.2,
    fiber: 2.1,
    defaultServing: 138,
    servingUnit: 'taza'
  },
  {
    id: 'fruit-19',
    name: 'Granada',
    category: 'Frutas',
    calories: 83,
    protein: 1.7,
    carbs: 19,
    fat: 1.2,
    fiber: 4,
    defaultServing: 87,
    servingUnit: 'taza de semillas'
  },
  {
    id: 'fruit-20',
    name: 'Mandarina',
    category: 'Frutas',
    calories: 53,
    protein: 0.8,
    carbs: 13,
    fat: 0.3,
    fiber: 1.8,
    defaultServing: 88,
    servingUnit: 'unidad mediana'
  },

  // VEGETABLES
  {
    id: 'veg-1',
    name: 'Brócoli',
    category: 'Verduras',
    calories: 34,
    protein: 2.8,
    carbs: 7,
    fat: 0.4,
    fiber: 2.6,
    defaultServing: 91,
    servingUnit: 'taza'
  },
  {
    id: 'veg-2',
    name: 'Espinaca',
    category: 'Verduras',
    calories: 23,
    protein: 2.9,
    carbs: 3.6,
    fat: 0.4,
    fiber: 2.2,
    defaultServing: 30,
    servingUnit: 'taza cruda'
  },
  {
    id: 'veg-3',
    name: 'Zanahoria',
    category: 'Verduras',
    calories: 41,
    protein: 0.9,
    carbs: 10,
    fat: 0.2,
    fiber: 2.8,
    defaultServing: 61,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'veg-4',
    name: 'Tomate',
    category: 'Verduras',
    calories: 18,
    protein: 0.9,
    carbs: 3.9,
    fat: 0.2,
    fiber: 1.2,
    defaultServing: 123,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'veg-5',
    name: 'Lechuga',
    category: 'Verduras',
    calories: 15,
    protein: 1.4,
    carbs: 2.9,
    fat: 0.2,
    fiber: 1.3,
    defaultServing: 36,
    servingUnit: 'taza'
  },
  {
    id: 'veg-6',
    name: 'Pepino',
    category: 'Verduras',
    calories: 16,
    protein: 0.7,
    carbs: 3.6,
    fat: 0.1,
    fiber: 0.5,
    defaultServing: 104,
    servingUnit: 'taza en rodajas'
  },
  {
    id: 'veg-7',
    name: 'Pimiento',
    category: 'Verduras',
    calories: 31,
    protein: 1,
    carbs: 6,
    fat: 0.3,
    fiber: 2.1,
    defaultServing: 119,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'veg-8',
    name: 'Cebolla',
    category: 'Verduras',
    calories: 40,
    protein: 1.1,
    carbs: 9,
    fat: 0.1,
    fiber: 1.7,
    defaultServing: 110,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'veg-9',
    name: 'Calabacín',
    category: 'Verduras',
    calories: 17,
    protein: 1.2,
    carbs: 3.1,
    fat: 0.3,
    fiber: 1,
    defaultServing: 124,
    servingUnit: 'taza en rodajas'
  },
  {
    id: 'veg-10',
    name: 'Berenjena',
    category: 'Verduras',
    calories: 25,
    protein: 1,
    carbs: 6,
    fat: 0.2,
    fiber: 3,
    defaultServing: 82,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'veg-11',
    name: 'Coliflor',
    category: 'Verduras',
    calories: 25,
    protein: 1.9,
    carbs: 5,
    fat: 0.3,
    fiber: 2,
    defaultServing: 100,
    servingUnit: 'taza'
  },
  {
    id: 'veg-12',
    name: 'Espárragos',
    category: 'Verduras',
    calories: 20,
    protein: 2.2,
    carbs: 3.9,
    fat: 0.1,
    fiber: 2.1,
    defaultServing: 134,
    servingUnit: 'taza'
  },
  {
    id: 'veg-13',
    name: 'Champiñones',
    category: 'Verduras',
    calories: 22,
    protein: 3.1,
    carbs: 3.3,
    fat: 0.3,
    fiber: 1,
    defaultServing: 70,
    servingUnit: 'taza'
  },
  {
    id: 'veg-14',
    name: 'Apio',
    category: 'Verduras',
    calories: 16,
    protein: 0.7,
    carbs: 3,
    fat: 0.2,
    fiber: 1.6,
    defaultServing: 101,
    servingUnit: 'taza en rodajas'
  },
  {
    id: 'veg-15',
    name: 'Rábano',
    category: 'Verduras',
    calories: 16,
    protein: 0.7,
    carbs: 3.4,
    fat: 0.1,
    fiber: 1.6,
    defaultServing: 116,
    servingUnit: 'taza en rodajas'
  },
  {
    id: 'veg-16',
    name: 'Col Rizada (Kale)',
    category: 'Verduras',
    calories: 49,
    protein: 4.3,
    carbs: 9,
    fat: 0.9,
    fiber: 3.6,
    defaultServing: 67,
    servingUnit: 'taza'
  },
  {
    id: 'veg-17',
    name: 'Acelga',
    category: 'Verduras',
    calories: 19,
    protein: 1.8,
    carbs: 3.7,
    fat: 0.2,
    fiber: 1.6,
    defaultServing: 36,
    servingUnit: 'taza'
  },
  {
    id: 'veg-18',
    name: 'Calabaza',
    category: 'Verduras',
    calories: 26,
    protein: 1,
    carbs: 6.5,
    fat: 0.1,
    fiber: 0.5,
    defaultServing: 116,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'veg-19',
    name: 'Remolacha',
    category: 'Verduras',
    calories: 43,
    protein: 1.6,
    carbs: 10,
    fat: 0.2,
    fiber: 2.8,
    defaultServing: 136,
    servingUnit: 'taza'
  },
  {
    id: 'veg-20',
    name: 'Ejotes',
    category: 'Verduras',
    calories: 31,
    protein: 1.8,
    carbs: 7,
    fat: 0.2,
    fiber: 2.7,
    defaultServing: 100,
    servingUnit: 'taza'
  },
  {
    id: 'veg-21',
    name: 'Ají Amarillo',
    category: 'Verduras',
    calories: 27,
    protein: 1.2,
    carbs: 5.8,
    fat: 0.3,
    fiber: 1.9,
    defaultServing: 50,
    servingUnit: 'unidad'
  },
  {
    id: 'veg-22',
    name: 'Ají Panca',
    category: 'Verduras',
    calories: 34,
    protein: 1.5,
    carbs: 7.2,
    fat: 0.4,
    fiber: 2.5,
    defaultServing: 15,
    servingUnit: 'unidad seca'
  },
  {
    id: 'veg-23',
    name: 'Rocoto',
    category: 'Verduras',
    calories: 40,
    protein: 1.8,
    carbs: 8.5,
    fat: 0.4,
    fiber: 2.3,
    defaultServing: 80,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'veg-24',
    name: 'Cebolla China (Cebollita de Verdeo)',
    category: 'Verduras',
    calories: 32,
    protein: 1.8,
    carbs: 7.3,
    fat: 0.2,
    fiber: 2.6,
    defaultServing: 50,
    servingUnit: 'taza picada'
  },
  {
    id: 'veg-25',
    name: 'Culantro (Cilantro)',
    category: 'Verduras',
    calories: 23,
    protein: 2.1,
    carbs: 3.7,
    fat: 0.5,
    fiber: 2.8,
    defaultServing: 10,
    servingUnit: 'cucharadas'
  },
  {
    id: 'veg-26',
    name: 'Poro (Puerro)',
    category: 'Verduras',
    calories: 61,
    protein: 1.5,
    carbs: 14,
    fat: 0.3,
    fiber: 1.8,
    defaultServing: 89,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'veg-27',
    name: 'Choclo (Maíz Tierno)',
    category: 'Verduras',
    calories: 86,
    protein: 3.2,
    carbs: 19,
    fat: 1.2,
    fiber: 2.7,
    defaultServing: 154,
    servingUnit: 'mazorca mediana'
  },
  {
    id: 'veg-28',
    name: 'Vainita (Judía Verde)',
    category: 'Verduras',
    calories: 31,
    protein: 1.8,
    carbs: 7,
    fat: 0.1,
    fiber: 2.7,
    defaultServing: 100,
    servingUnit: 'taza'
  },
  {
    id: 'veg-29',
    name: 'Zapallo Macre',
    category: 'Verduras',
    calories: 26,
    protein: 1.0,
    carbs: 6.5,
    fat: 0.1,
    fiber: 0.5,
    defaultServing: 120,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'veg-30',
    name: 'Alcachofa',
    category: 'Verduras',
    calories: 47,
    protein: 3.3,
    carbs: 10.5,
    fat: 0.2,
    fiber: 5.4,
    defaultServing: 120,
    servingUnit: 'unidad mediana'
  },

  // PROTEINS - MEAT
  {
    id: 'protein-1',
    name: 'Pechuga de Pollo',
    category: 'Proteínas',
    calories: 165,
    protein: 31,
    carbs: 0,
    fat: 3.6,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-2',
    name: 'Carne de Res Magra',
    category: 'Proteínas',
    calories: 250,
    protein: 26,
    carbs: 0,
    fat: 15,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-3',
    name: 'Pavo',
    category: 'Proteínas',
    calories: 135,
    protein: 30,
    carbs: 0,
    fat: 0.7,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-4',
    name: 'Cerdo Magro',
    category: 'Proteínas',
    calories: 242,
    protein: 27,
    carbs: 0,
    fat: 14,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-5',
    name: 'Salmón',
    category: 'Proteínas',
    calories: 208,
    protein: 20,
    carbs: 0,
    fat: 13,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-6',
    name: 'Atún',
    category: 'Proteínas',
    calories: 132,
    protein: 28,
    carbs: 0,
    fat: 1.3,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-7',
    name: 'Tilapia',
    category: 'Proteínas',
    calories: 128,
    protein: 26,
    carbs: 0,
    fat: 2.7,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-8',
    name: 'Camarones',
    category: 'Proteínas',
    calories: 99,
    protein: 24,
    carbs: 0.2,
    fat: 0.3,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-9',
    name: 'Bistec de Res',
    category: 'Proteínas',
    calories: 271,
    protein: 25,
    carbs: 0,
    fat: 19,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-10',
    name: 'Huevo Entero',
    category: 'Proteínas',
    calories: 155,
    protein: 13,
    carbs: 1.1,
    fat: 11,
    fiber: 0,
    defaultServing: 50,
    servingUnit: 'unidad grande'
  },
  {
    id: 'protein-11',
    name: 'Claras de Huevo',
    category: 'Proteínas',
    calories: 52,
    protein: 11,
    carbs: 0.7,
    fat: 0.2,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-12',
    name: 'Muslo de Pollo',
    category: 'Proteínas',
    calories: 209,
    protein: 26,
    carbs: 0,
    fat: 11,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-13',
    name: 'Bacalao',
    category: 'Proteínas',
    calories: 105,
    protein: 23,
    carbs: 0,
    fat: 0.9,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-14',
    name: 'Sardinas en Lata',
    category: 'Proteínas',
    calories: 208,
    protein: 25,
    carbs: 0,
    fat: 11,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-15',
    name: 'Calamar',
    category: 'Proteínas',
    calories: 92,
    protein: 16,
    carbs: 3.1,
    fat: 1.4,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-16',
    name: 'Cuy (Cobayo)',
    category: 'Proteínas',
    calories: 160,
    protein: 20.3,
    carbs: 0,
    fat: 7.8,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-17',
    name: 'Alpaca',
    category: 'Proteínas',
    calories: 119,
    protein: 22.5,
    carbs: 0,
    fat: 3.2,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-18',
    name: 'Trucha',
    category: 'Proteínas',
    calories: 141,
    protein: 19.9,
    carbs: 0,
    fat: 6.2,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-19',
    name: 'Bonito',
    category: 'Proteínas',
    calories: 144,
    protein: 21.5,
    carbs: 0,
    fat: 6.0,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-20',
    name: 'Jurel',
    category: 'Proteínas',
    calories: 112,
    protein: 18.5,
    carbs: 0,
    fat: 4.0,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-21',
    name: 'Caballa',
    category: 'Proteínas',
    calories: 205,
    protein: 19.0,
    carbs: 0,
    fat: 13.9,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-22',
    name: 'Lenguado',
    category: 'Proteínas',
    calories: 91,
    protein: 18.8,
    carbs: 0,
    fat: 1.2,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-23',
    name: 'Pulpo',
    category: 'Proteínas',
    calories: 82,
    protein: 14.9,
    carbs: 2.2,
    fat: 1.0,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-24',
    name: 'Concha de Abanico',
    category: 'Proteínas',
    calories: 88,
    protein: 16.8,
    carbs: 3.2,
    fat: 0.8,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-25',
    name: 'Langostino',
    category: 'Proteínas',
    calories: 106,
    protein: 20.3,
    carbs: 0.9,
    fat: 1.7,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-26',
    name: 'Pollo Entero con Piel',
    category: 'Proteínas',
    calories: 239,
    protein: 27.3,
    carbs: 0,
    fat: 13.6,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-27',
    name: 'Hígado de Res',
    category: 'Proteínas',
    calories: 135,
    protein: 20.4,
    carbs: 3.9,
    fat: 3.6,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'protein-28',
    name: 'Corazón de Res',
    category: 'Proteínas',
    calories: 112,
    protein: 17.7,
    carbs: 0.1,
    fat: 3.9,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g'
  },

  // GRAINS & CEREALS
  {
    id: 'grain-1',
    name: 'Arroz Blanco Cocido',
    category: 'Granos y Cereales',
    calories: 130,
    protein: 2.7,
    carbs: 28,
    fat: 0.3,
    fiber: 0.4,
    defaultServing: 186,
    servingUnit: 'taza cocida'
  },
  {
    id: 'grain-2',
    name: 'Arroz Integral',
    category: 'Granos y Cereales',
    calories: 111,
    protein: 2.6,
    carbs: 23,
    fat: 0.9,
    fiber: 1.8,
    defaultServing: 195,
    servingUnit: 'taza cocida'
  },
  {
    id: 'grain-3',
    name: 'Avena',
    category: 'Granos y Cereales',
    calories: 389,
    protein: 17,
    carbs: 66,
    fat: 7,
    fiber: 10.6,
    defaultServing: 40,
    servingUnit: 'taza seca'
  },
  {
    id: 'grain-4',
    name: 'Pan Integral',
    category: 'Granos y Cereales',
    calories: 247,
    protein: 13,
    carbs: 41,
    fat: 4.2,
    fiber: 6.8,
    defaultServing: 28,
    servingUnit: 'rebanada'
  },
  {
    id: 'grain-5',
    name: 'Pan Blanco',
    category: 'Granos y Cereales',
    calories: 265,
    protein: 9,
    carbs: 49,
    fat: 3.2,
    fiber: 2.7,
    defaultServing: 28,
    servingUnit: 'rebanada'
  },
  {
    id: 'grain-6',
    name: 'Pasta Cocida',
    category: 'Granos y Cereales',
    calories: 131,
    protein: 5,
    carbs: 25,
    fat: 1.1,
    fiber: 1.8,
    defaultServing: 140,
    servingUnit: 'taza cocida'
  },
  {
    id: 'grain-7',
    name: 'Quinoa Cocida',
    category: 'Granos y Cereales',
    calories: 120,
    protein: 4.4,
    carbs: 21.3,
    fat: 1.9,
    fiber: 2.8,
    defaultServing: 185,
    servingUnit: 'taza cocida'
  },
  {
    id: 'grain-8',
    name: 'Maíz Amarillo',
    category: 'Granos y Cereales',
    calories: 365,
    protein: 9.4,
    carbs: 74,
    fat: 4.7,
    fiber: 7.3,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'grain-9',
    name: 'Cebada Perlada',
    category: 'Granos y Cereales',
    calories: 354,
    protein: 12.5,
    carbs: 73.5,
    fat: 2.3,
    fiber: 17.3,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'grain-10',
    name: 'Trigo Cocido',
    category: 'Granos y Cereales',
    calories: 136,
    protein: 4.8,
    carbs: 28,
    fat: 0.9,
    fiber: 4.5,
    defaultServing: 180,
    servingUnit: 'taza cocida'
  },
  {
    id: 'grain-11',
    name: 'Quinoa Cruda',
    category: 'Granos y Cereales',
    calories: 102,
    protein: 3.8,
    carbs: 18.8,
    fat: 1.6,
    fiber: 2.1,
    defaultServing: 185,
    servingUnit: 'taza cocida'
  },
  {
    id: 'grain-12',
    name: 'Kiwicha (Amaranto) Cruda',
    category: 'Granos y Cereales',
    calories: 371,
    protein: 13.6,
    carbs: 65.3,
    fat: 7.0,
    fiber: 6.7,
    defaultServing: 45,
    servingUnit: '1/4 taza seca'
  },
  {
    id: 'grain-13',
    name: 'Maíz Morado',
    category: 'Granos y Cereales',
    calories: 362,
    protein: 8.7,
    carbs: 76.5,
    fat: 3.5,
    fiber: 4.8,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'grain-14',
    name: 'Maíz Blanco (Mote)',
    category: 'Granos y Cereales',
    calories: 362,
    protein: 8.5,
    carbs: 76.8,
    fat: 3.8,
    fiber: 4.6,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'grain-15',
    name: 'Pan Francés (Baguette)',
    category: 'Granos y Cereales',
    calories: 274,
    protein: 9.0,
    carbs: 55.0,
    fat: 1.5,
    fiber: 2.3,
    defaultServing: 50,
    servingUnit: 'unidad pequeña'
  },
  {
    id: 'grain-16',
    name: 'Galleta de Soda',
    category: 'Granos y Cereales',
    calories: 421,
    protein: 9.5,
    carbs: 70.0,
    fat: 11.0,
    fiber: 2.2,
    defaultServing: 30,
    servingUnit: '5 galletas'
  },

  // DAIRY
  {
    id: 'dairy-1',
    name: 'Leche Entera',
    category: 'Lácteos',
    calories: 61,
    protein: 3.2,
    carbs: 4.8,
    fat: 3.3,
    fiber: 0,
    defaultServing: 244,
    servingUnit: 'taza'
  },
  {
    id: 'dairy-2',
    name: 'Leche Descremada',
    category: 'Lácteos',
    calories: 34,
    protein: 3.4,
    carbs: 5,
    fat: 0.2,
    fiber: 0,
    defaultServing: 244,
    servingUnit: 'taza'
  },
  {
    id: 'dairy-3',
    name: 'Yogur Natural',
    category: 'Lácteos',
    calories: 61,
    protein: 3.5,
    carbs: 4.7,
    fat: 3.3,
    fiber: 0,
    defaultServing: 245,
    servingUnit: 'taza'
  },
  {
    id: 'dairy-4',
    name: 'Yogur Griego',
    category: 'Lácteos',
    calories: 97,
    protein: 9,
    carbs: 3.6,
    fat: 5,
    fiber: 0,
    defaultServing: 245,
    servingUnit: 'taza'
  },
  {
    id: 'dairy-5',
    name: 'Queso Cottage',
    category: 'Lácteos',
    calories: 98,
    protein: 11,
    carbs: 3.4,
    fat: 4.3,
    fiber: 0,
    defaultServing: 113,
    servingUnit: 'taza'
  },
  {
    id: 'dairy-6',
    name: 'Queso Cheddar',
    category: 'Lácteos',
    calories: 402,
    protein: 25,
    carbs: 1.3,
    fat: 33,
    fiber: 0,
    defaultServing: 28,
    servingUnit: 'rebanada'
  },
  {
    id: 'dairy-7',
    name: 'Queso Mozzarella',
    category: 'Lácteos',
    calories: 280,
    protein: 28,
    carbs: 2.2,
    fat: 17,
    fiber: 0,
    defaultServing: 28,
    servingUnit: 'rebanada'
  },
  {
    id: 'dairy-8',
    name: 'Mantequilla',
    category: 'Lácteos',
    calories: 717,
    protein: 0.9,
    carbs: 0.1,
    fat: 81,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada'
  },
  {
    id: 'dairy-9',
    name: 'Crema de Leche',
    category: 'Lácteos',
    calories: 340,
    protein: 2.1,
    carbs: 2.8,
    fat: 36,
    fiber: 0,
    defaultServing: 30,
    servingUnit: 'cucharada'
  },
  {
    id: 'dairy-10',
    name: 'Leche Evaporada',
    category: 'Lácteos',
    calories: 134,
    protein: 6.8,
    carbs: 10.0,
    fat: 7.6,
    fiber: 0,
    defaultServing: 120,
    servingUnit: 'taza'
  },
  {
    id: 'dairy-11',
    name: 'Queso Fresco',
    category: 'Lácteos',
    calories: 264,
    protein: 18.0,
    carbs: 2.5,
    fat: 20.0,
    fiber: 0,
    defaultServing: 30,
    servingUnit: 'rebanada'
  },
  {
    id: 'dairy-12',
    name: 'Queso Andino',
    category: 'Lácteos',
    calories: 350,
    protein: 22.0,
    carbs: 2.0,
    fat: 28.0,
    fiber: 0,
    defaultServing: 30,
    servingUnit: 'rebanada'
  },

  // LEGUMES
  {
    id: 'legume-1',
    name: 'Frijoles Negros Cocidos',
    category: 'Legumbres',
    calories: 132,
    protein: 8.9,
    carbs: 24,
    fat: 0.5,
    fiber: 8.7,
    defaultServing: 172,
    servingUnit: 'taza cocida'
  },
  {
    id: 'legume-2',
    name: 'Lentejas Cocidas',
    category: 'Legumbres',
    calories: 116,
    protein: 9,
    carbs: 20,
    fat: 0.4,
    fiber: 7.9,
    defaultServing: 198,
    servingUnit: 'taza cocida'
  },
  {
    id: 'legume-3',
    name: 'Garbanzos Cocidos',
    category: 'Legumbres',
    calories: 164,
    protein: 8.9,
    carbs: 27,
    fat: 2.6,
    fiber: 7.6,
    defaultServing: 164,
    servingUnit: 'taza cocida'
  },
  {
    id: 'legume-4',
    name: 'Frijoles Rojos Cocidos',
    category: 'Legumbres',
    calories: 127,
    protein: 8.7,
    carbs: 23,
    fat: 0.5,
    fiber: 6.4,
    defaultServing: 177,
    servingUnit: 'taza cocida'
  },
  {
    id: 'legume-5',
    name: 'Edamame',
    category: 'Legumbres',
    calories: 122,
    protein: 11,
    carbs: 10,
    fat: 5,
    fiber: 5.2,
    defaultServing: 155,
    servingUnit: 'taza'
  },
  {
    id: 'legume-6',
    name: 'Tofu',
    category: 'Legumbres',
    calories: 76,
    protein: 8,
    carbs: 1.9,
    fat: 4.8,
    fiber: 0.3,
    defaultServing: 126,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'legume-7',
    name: 'Frijoles Blancos Cocidos',
    category: 'Legumbres',
    calories: 139,
    protein: 9.7,
    carbs: 25,
    fat: 0.4,
    fiber: 6.3,
    defaultServing: 179,
    servingUnit: 'taza cocida'
  },
  {
    id: 'legume-8',
    name: 'Arvejas (Guisantes) Cocidas',
    category: 'Legumbres',
    calories: 84,
    protein: 5.4,
    carbs: 15.6,
    fat: 0.4,
    fiber: 5.5,
    defaultServing: 160,
    servingUnit: 'taza cocida'
  },
  {
    id: 'legume-9',
    name: 'Pallares (Habas Lima) Cocidos',
    category: 'Legumbres',
    calories: 115,
    protein: 7.8,
    carbs: 20.9,
    fat: 0.4,
    fiber: 7.0,
    defaultServing: 170,
    servingUnit: 'taza cocida'
  },
  {
    id: 'legume-10',
    name: 'Habas Cocidas',
    category: 'Legumbres',
    calories: 110,
    protein: 7.6,
    carbs: 19.7,
    fat: 0.4,
    fiber: 5.4,
    defaultServing: 170,
    servingUnit: 'taza cocida'
  },
  {
    id: 'legume-11',
    name: 'Frijol Canario Cocido',
    category: 'Legumbres',
    calories: 130,
    protein: 9.0,
    carbs: 23.5,
    fat: 0.5,
    fiber: 6.8,
    defaultServing: 170,
    servingUnit: 'taza cocida'
  },
  {
    id: 'legume-12',
    name: 'Maní (Cacahuete) Tostado',
    category: 'Legumbres',
    calories: 585,
    protein: 23.7,
    carbs: 21.5,
    fat: 49.7,
    fiber: 8.5,
    defaultServing: 30,
    servingUnit: 'puñado'
  },

  // NUTS & SEEDS
  {
    id: 'nut-1',
    name: 'Almendras',
    category: 'Nueces y Semillas',
    calories: 579,
    protein: 21,
    carbs: 22,
    fat: 50,
    fiber: 12.5,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 143, cucharada: 9, '100g': 100 }
  },
  {
    id: 'nut-2',
    name: 'Nueces',
    category: 'Nueces y Semillas',
    calories: 654,
    protein: 15,
    carbs: 14,
    fat: 65,
    fiber: 6.7,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 117, cucharada: 7, '100g': 100 }
  },
  {
    id: 'nut-3',
    name: 'Semillas de Chía',
    category: 'Nueces y Semillas',
    calories: 486,
    protein: 17,
    carbs: 42,
    fat: 31,
    fiber: 34,
    defaultServing: 28,
    servingUnit: '2 cucharadas',
    servingConversions: { '2 cucharadas': 28, cucharada: 14, taza: 160, '100g': 100 }
  },
  {
    id: 'nut-4',
    name: 'Semillas de Girasol',
    category: 'Nueces y Semillas',
    calories: 584,
    protein: 21,
    carbs: 20,
    fat: 51,
    fiber: 8.6,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 140, cucharada: 9, '100g': 100 }
  },
  {
    id: 'nut-5',
    name: 'Semillas de Calabaza',
    category: 'Nueces y Semillas',
    calories: 559,
    protein: 30,
    carbs: 11,
    fat: 49,
    fiber: 6,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 129, cucharada: 9, '100g': 100 }
  },
  {
    id: 'nut-6',
    name: 'Pistachos',
    category: 'Nueces y Semillas',
    calories: 562,
    protein: 20,
    carbs: 28,
    fat: 45,
    fiber: 10,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 140, cucharada: 9, '100g': 100 }
  },
  {
    id: 'nut-7',
    name: 'Anacardos (Cashews)',
    category: 'Nueces y Semillas',
    calories: 553,
    protein: 18,
    carbs: 30,
    fat: 44,
    fiber: 3.3,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 109, cucharada: 7, '100g': 100 }
  },
  {
    id: 'nut-8',
    name: 'Semillas de Lino',
    category: 'Nueces y Semillas',
    calories: 534,
    protein: 18,
    carbs: 29,
    fat: 42,
    fiber: 27,
    defaultServing: 14,
    servingUnit: 'cucharada',
    servingConversions: { cucharada: 14, cucharadita: 5, taza: 149, '100g': 100 }
  },
  {
    id: 'nut-9',
    name: 'Nuez de Brasil',
    category: 'Nueces y Semillas',
    calories: 659,
    protein: 14.3,
    carbs: 12.3,
    fat: 67.1,
    fiber: 7.5,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 129, cucharada: 9, '100g': 100 }
  },

  // OILS & FATS
  {
    id: 'oil-1',
    name: 'Aceite de Oliva',
    category: 'Aceites y Grasas',
    calories: 884,
    protein: 0,
    carbs: 0,
    fat: 100,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada'
  },
  {
    id: 'oil-2',
    name: 'Aceite de Coco',
    category: 'Aceites y Grasas',
    calories: 862,
    protein: 0,
    carbs: 0,
    fat: 100,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada'
  },
  {
    id: 'oil-3',
    name: 'Aceite de Girasol',
    category: 'Aceites y Grasas',
    calories: 884,
    protein: 0,
    carbs: 0,
    fat: 100,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada'
  },
  {
    id: 'oil-4',
    name: 'Aguacate (Palta)',
    category: 'Aceites y Grasas',
    calories: 160,
    protein: 2,
    carbs: 9,
    fat: 15,
    fiber: 6.7,
    defaultServing: 150,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'oil-5',
    name: 'Aceite de Soya',
    category: 'Aceites y Grasas',
    calories: 884,
    protein: 0,
    carbs: 0,
    fat: 100,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada'
  },

  // BEVERAGES
  {
    id: 'bev-1',
    name: 'Agua',
    category: 'Bebidas',
    calories: 0,
    protein: 0,
    carbs: 0,
    fat: 0,
    fiber: 0,
    defaultServing: 240,
    servingUnit: 'vaso'
  },
  {
    id: 'bev-2',
    name: 'Café Negro',
    category: 'Bebidas',
    calories: 2,
    protein: 0.3,
    carbs: 0,
    fat: 0,
    fiber: 0,
    defaultServing: 240,
    servingUnit: 'taza'
  },
  {
    id: 'bev-3',
    name: 'Té Verde',
    category: 'Bebidas',
    calories: 1,
    protein: 0,
    carbs: 0.2,
    fat: 0,
    fiber: 0,
    defaultServing: 240,
    servingUnit: 'taza'
  },
  {
    id: 'bev-4',
    name: 'Jugo de Naranja Natural',
    category: 'Bebidas',
    calories: 45,
    protein: 0.7,
    carbs: 10,
    fat: 0.2,
    fiber: 0.2,
    defaultServing: 240,
    servingUnit: 'vaso'
  },
  {
    id: 'bev-5',
    name: 'Leche de Almendras',
    category: 'Bebidas',
    calories: 17,
    protein: 0.6,
    carbs: 1.5,
    fat: 1.1,
    fiber: 0.3,
    defaultServing: 240,
    servingUnit: 'taza'
  },
  {
    id: 'bev-6',
    name: 'Batido de Proteína',
    category: 'Bebidas',
    calories: 120,
    protein: 25,
    carbs: 5,
    fat: 1.5,
    fiber: 1,
    defaultServing: 300,
    servingUnit: 'vaso'
  },
  {
    id: 'bev-7',
    name: 'Chicha Morada',
    category: 'Bebidas',
    calories: 55,
    protein: 0.3,
    carbs: 13.5,
    fat: 0.1,
    fiber: 0.2,
    defaultServing: 250,
    servingUnit: 'vaso'
  },
  {
    id: 'bev-8',
    name: 'Emoliente',
    category: 'Bebidas',
    calories: 45,
    protein: 0.5,
    carbs: 10.5,
    fat: 0.1,
    fiber: 0.8,
    defaultServing: 250,
    servingUnit: 'vaso'
  },
  {
    id: 'bev-9',
    name: 'Maca en Polvo',
    category: 'Bebidas',
    calories: 325,
    protein: 14.0,
    carbs: 71.4,
    fat: 2.2,
    fiber: 8.5,
    defaultServing: 10,
    servingUnit: 'cucharadita'
  },
  {
    id: 'bev-10',
    name: 'Leche de Soya',
    category: 'Bebidas',
    calories: 33,
    protein: 2.9,
    carbs: 1.7,
    fat: 1.8,
    fiber: 0.3,
    defaultServing: 240,
    servingUnit: 'taza'
  },
  {
    id: 'bev-11',
    name: 'Jugo de Maracuyá Natural',
    category: 'Bebidas',
    calories: 51,
    protein: 1.0,
    carbs: 11.2,
    fat: 0.4,
    fiber: 0.4,
    defaultServing: 250,
    servingUnit: 'vaso'
  },
  {
    id: 'bev-12',
    name: 'Jugo de Lúcuma',
    category: 'Bebidas',
    calories: 48,
    protein: 0.6,
    carbs: 11.0,
    fat: 0.2,
    fiber: 0.5,
    defaultServing: 250,
    servingUnit: 'vaso'
  },

  // PREPARED DISHES
  {
    id: 'dish-1',
    name: 'Ensalada César',
    category: 'Platos Preparados',
    calories: 158,
    protein: 7,
    carbs: 8,
    fat: 12,
    fiber: 2,
    defaultServing: 200,
    servingUnit: 'porción'
  },
  {
    id: 'dish-2',
    name: 'Pizza Margarita',
    category: 'Platos Preparados',
    calories: 266,
    protein: 11,
    carbs: 33,
    fat: 10,
    fiber: 2.3,
    defaultServing: 107,
    servingUnit: 'rebanada'
  },
  {
    id: 'dish-3',
    name: 'Hamburguesa',
    category: 'Platos Preparados',
    calories: 295,
    protein: 17,
    carbs: 24,
    fat: 14,
    fiber: 1,
    defaultServing: 150,
    servingUnit: 'unidad'
  },
  {
    id: 'dish-4',
    name: 'Tacos de Pollo',
    category: 'Platos Preparados',
    calories: 226,
    protein: 17,
    carbs: 20,
    fat: 8,
    fiber: 2,
    defaultServing: 150,
    servingUnit: '2 tacos'
  },
  {
    id: 'dish-5',
    name: 'Sushi Roll',
    category: 'Platos Preparados',
    calories: 200,
    protein: 9,
    carbs: 38,
    fat: 2,
    fiber: 1,
    defaultServing: 150,
    servingUnit: '6 piezas'
  },
  {
    id: 'dish-6',
    name: 'Sopa de Pollo',
    category: 'Platos Preparados',
    calories: 75,
    protein: 6,
    carbs: 9,
    fat: 2,
    fiber: 1,
    defaultServing: 240,
    servingUnit: 'taza'
  },
  {
    id: 'dish-7',
    name: 'Burrito de Frijoles',
    category: 'Platos Preparados',
    calories: 206,
    protein: 8,
    carbs: 34,
    fat: 5,
    fiber: 5,
    defaultServing: 200,
    servingUnit: 'unidad'
  },
  {
    id: 'dish-8',
    name: 'Pasta con Salsa de Tomate',
    category: 'Platos Preparados',
    calories: 174,
    protein: 6,
    carbs: 34,
    fat: 2,
    fiber: 3,
    defaultServing: 200,
    servingUnit: 'porción'
  },
  {
    id: 'dish-9',
    name: 'Arroz con Pollo',
    category: 'Platos Preparados',
    calories: 185,
    protein: 14,
    carbs: 22,
    fat: 4,
    fiber: 1,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'dish-10',
    name: 'Omelette de Verduras',
    category: 'Platos Preparados',
    calories: 154,
    protein: 11,
    carbs: 4,
    fat: 11,
    fiber: 1,
    defaultServing: 150,
    servingUnit: 'porción'
  },
  {
    id: 'dish-11',
    name: 'Ensalada de Atún',
    category: 'Platos Preparados',
    calories: 187,
    protein: 20,
    carbs: 5,
    fat: 10,
    fiber: 1,
    defaultServing: 200,
    servingUnit: 'porción'
  },
  {
    id: 'dish-12',
    name: 'Pollo a la Plancha',
    category: 'Platos Preparados',
    calories: 165,
    protein: 31,
    carbs: 0,
    fat: 3.6,
    fiber: 0,
    defaultServing: 150,
    servingUnit: 'porción'
  },
  {
    id: 'dish-13',
    name: 'Ceviche',
    category: 'Platos Preparados',
    calories: 120,
    protein: 18,
    carbs: 8,
    fat: 2,
    fiber: 1,
    defaultServing: 150,
    servingUnit: 'porción'
  },
  {
    id: 'dish-14',
    name: 'Tamales',
    category: 'Platos Preparados',
    calories: 285,
    protein: 8,
    carbs: 38,
    fat: 11,
    fiber: 5,
    defaultServing: 100,
    servingUnit: 'unidad'
  },
  {
    id: 'dish-15',
    name: 'Fajitas de Res',
    category: 'Platos Preparados',
    calories: 245,
    protein: 22,
    carbs: 15,
    fat: 12,
    fiber: 2,
    defaultServing: 200,
    servingUnit: 'porción'
  },

  // ─────────────────────────────────────────────────────────────────────────
  // FRUTAS PERUANAS Y TROPICALES (INS Tablas Peruanas de Composición de Alimentos)
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'fruta-pe-1',
    name: 'Lúcuma',
    category: 'Frutas Peruanas',
    calories: 99,
    protein: 1.5,
    carbs: 23.8,
    fat: 0.5,
    fiber: 1.9,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-2',
    name: 'Maracuyá (Fruta de la Pasión)',
    category: 'Frutas Peruanas',
    calories: 97,
    protein: 2.2,
    carbs: 23.4,
    fat: 0.7,
    fiber: 10.4,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-3',
    name: 'Chirimoya',
    category: 'Frutas Peruanas',
    calories: 75,
    protein: 1.6,
    carbs: 17.7,
    fat: 0.6,
    fiber: 2.4,
    defaultServing: 150,
    servingUnit: 'porción'
  },
  {
    id: 'fruta-pe-4',
    name: 'Guanábana',
    category: 'Frutas Peruanas',
    calories: 66,
    protein: 1.0,
    carbs: 16.8,
    fat: 0.3,
    fiber: 3.3,
    defaultServing: 150,
    servingUnit: 'porción'
  },
  {
    id: 'fruta-pe-5',
    name: 'Camu Camu',
    category: 'Frutas Peruanas',
    calories: 17,
    protein: 0.5,
    carbs: 4.0,
    fat: 0.2,
    fiber: 0.6,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-6',
    name: 'Aguaymanto (Physalis)',
    category: 'Frutas Peruanas',
    calories: 53,
    protein: 1.9,
    carbs: 11.2,
    fat: 0.7,
    fiber: 3.9,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-7',
    name: 'Tuna (Higo Chumbo)',
    category: 'Frutas Peruanas',
    calories: 41,
    protein: 0.7,
    carbs: 9.6,
    fat: 0.5,
    fiber: 3.6,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-8',
    name: 'Pacay (Guaba)',
    category: 'Frutas Peruanas',
    calories: 73,
    protein: 1.5,
    carbs: 17.5,
    fat: 0.3,
    fiber: 2.0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-9',
    name: 'Cocona',
    category: 'Frutas Peruanas',
    calories: 26,
    protein: 0.9,
    carbs: 5.8,
    fat: 0.2,
    fiber: 1.0,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-10',
    name: 'Ciruela',
    category: 'Frutas Peruanas',
    calories: 31,
    protein: 1.0,
    carbs: 6.7,
    fat: 0.3,
    fiber: 2.8,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-11',
    name: 'Tambillo',
    category: 'Frutas Peruanas',
    calories: 36,
    protein: 0.8,
    carbs: 6.5,
    fat: 0.2,
    fiber: 1.5,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-12',
    name: 'Mora',
    category: 'Frutas Peruanas',
    calories: 43,
    protein: 0.8,
    carbs: 6.5,
    fat: 0.2,
    fiber: 1.5,
    defaultServing: 100,
    servingUnit: '100g'
  },
  {
    id: 'fruta-pe-13',
    name: 'Mango',
    category: 'Frutas Peruanas',
    calories: 60,
    protein: 0.8,
    carbs: 15,
    fat: 0.4,
    fiber: 1.6,
    defaultServing: 165,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'fruta-pe-14',
    name: 'Piña',
    category: 'Frutas Peruanas',
    calories: 50,
    protein: 0.5,
    carbs: 13,
    fat: 0.1,
    fiber: 1.4,
    defaultServing: 165,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'fruta-pe-15',
    name: 'Ciruela',
    category: 'Frutas Peruanas',
    calories: 46,
    protein: 0.7,
    carbs: 11,
    fat: 0.3,
    fiber: 1.4,
    defaultServing: 66,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'fruta-pe-16',
    name: 'Fresa',
    category: 'Frutas Peruanas',
    calories: 32,
    protein: 0.7,
    carbs: 8,
    fat: 0.3,
    fiber: 2,
    defaultServing: 150,
    servingUnit: 'taza'
  },
  {
    id: 'fruta-pe-17',
    name: 'Sandía',
    category: 'Frutas Peruanas',
    calories: 30,
    protein: 0.6,
    carbs: 8,
    fat: 0.2,
    fiber: 0.4,
    defaultServing: 280,
    servingUnit: 'rodaja'
  },
  {
    id: 'fruta-pe-18',
    name: 'Uvas',
    category: 'Frutas Peruanas',
    calories: 69,
    protein: 0.7,
    carbs: 18,
    fat: 0.2,
    fiber: 0.9,
    defaultServing: 150,
    servingUnit: 'taza'
  },
  {
    id: 'fruta-pe-19',
    name: 'Mango',
    category: 'Frutas Peruanas',
    calories: 60,
    protein: 0.8,
    carbs: 15,
    fat: 0.4,
    fiber: 1.6,
    defaultServing: 165,
    servingUnit: 'taza en cubos'
  },
  {
    id: 'fruta-pe-20',
    name: 'Piña',
    category: 'Frutas Peruanas',
    calories: 50,
    protein: 0.5,
    carbs: 13,
    fat: 0.1,
    fiber: 1.4,
    defaultServing: 165,
    servingUnit: 'taza en cubos'
  },

  // ─────────────────────────────────────────────────────────────────────────
  // TUBÉRCULOS Y RAÍCES (INS Tablas Peruanas de Composición de Alimentos)
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'tub-1',
    name: 'Papa Blanca Cocida',
    category: 'Tubérculos y Raíces',
    calories: 77,
    protein: 2.0,
    carbs: 17.5,
    fat: 0.1,
    fiber: 1.8,
    defaultServing: 150,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'tub-2',
    name: 'Papa Amarilla Cocida',
    category: 'Tubérculos y Raíces',
    calories: 82,
    protein: 2.1,
    carbs: 18.5,
    fat: 0.1,
    fiber: 1.6,
    defaultServing: 150,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'tub-3',
    name: 'Papa Huayro Cocida',
    category: 'Tubérculos y Raíces',
    calories: 79,
    protein: 2.0,
    carbs: 17.8,
    fat: 0.1,
    fiber: 1.9,
    defaultServing: 150,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'tub-4',
    name: 'Papa Negra (Tomasa)',
    category: 'Tubérculos y Raíces',
    calories: 80,
    protein: 2.1,
    carbs: 18.0,
    fat: 0.1,
    fiber: 2.0,
    defaultServing: 150,
    servingUnit: 'unidad mediana'
  },
  {
    id: 'tub-5',
    name: 'Chuño (Papa Deshidratada)',
    category: 'Tubérculos y Raíces',
    calories: 330,
    protein: 7.0,
    carbs: 75.0,
    fat: 0.5,
    fiber: 8.0,
    defaultServing: 50,
    servingUnit: 'porción seca',
    servingConversions: { porción: 50, cucharada: 15, '100g': 100 }
  },
  {
    id: 'tub-6',
    name: 'Moraya (Chuño Blanco)',
    category: 'Tubérculos y Raíces',
    calories: 320,
    protein: 6.5,
    carbs: 73.0,
    fat: 0.4,
    fiber: 7.5,
    defaultServing: 50,
    servingUnit: 'porción seca',
    servingConversions: { porción: 50, cucharada: 15, '100g': 100 }
  },
  {
    id: 'tub-7',
    name: 'Camote (Boniato) Cocido',
    category: 'Tubérculos y Raíces',
    calories: 86,
    protein: 1.6,
    carbs: 20.1,
    fat: 0.1,
    fiber: 3.0,
    defaultServing: 130,
    servingUnit: 'unidad mediana',
    servingConversions: { unidad: 130, taza: 200, '100g': 100 }
  },
  {
    id: 'tub-8',
    name: 'Yuca (Mandioca) Cocida',
    category: 'Tubérculos y Raíces',
    calories: 160,
    protein: 1.4,
    carbs: 38.1,
    fat: 0.3,
    fiber: 1.8,
    defaultServing: 100,
    servingUnit: '100g',
    servingConversions: { '100g': 100 }
  },
  {
    id: 'tub-9',
    name: 'Oca Cocida',
    category: 'Tubérculos y Raíces',
    calories: 61,
    protein: 1.0,
    carbs: 14.0,
    fat: 0.1,
    fiber: 1.5,
    defaultServing: 100,
    servingUnit: '100g',
    servingConversions: { '100g': 100 }
  },
  {
    id: 'tub-10',
    name: 'Olluco Cocido',
    category: 'Tubérculos y Raíces',
    calories: 57,
    protein: 1.1,
    carbs: 13.0,
    fat: 0.1,
    fiber: 1.0,
    defaultServing: 100,
    servingUnit: '100g',
    servingConversions: { '100g': 100 }
  },
  {
    id: 'tub-11',
    name: 'Mashua (Isaño) Cocida',
    category: 'Tubérculos y Raíces',
    calories: 52,
    protein: 1.5,
    carbs: 11.5,
    fat: 0.1,
    fiber: 1.8,
    defaultServing: 100,
    servingUnit: '100g',
    servingConversions: { '100g': 100 }
  },
  {
    id: 'tub-12',
    name: 'Arracacha (Zanahoria Blanca) Cocida',
    category: 'Tubérculos y Raíces',
    calories: 94,
    protein: 1.0,
    carbs: 22.0,
    fat: 0.3,
    fiber: 1.4,
    defaultServing: 100,
    servingUnit: '100g',
    servingConversions: { '100g': 100 }
  },
  {
    id: 'tub-13',
    name: 'Maca en Polvo',
    category: 'Tubérculos y Raíces',
    calories: 325,
    protein: 10.2,
    carbs: 65.0,
    fat: 2.2,
    fiber: 8.5,
    defaultServing: 10,
    servingUnit: 'cucharadita',
    servingConversions: { cucharadita: 5, cucharada: 10, '100g': 100 }
  },
  {
    id: 'tub-14',
    name: 'Papa Seca',
    category: 'Tubérculos y Raíces',
    calories: 340,
    protein: 7.5,
    carbs: 77.0,
    fat: 0.5,
    fiber: 6.5,
    defaultServing: 50,
    servingUnit: 'porción seca',
    servingConversions: { porción: 50, '100g': 100 }
  },
  {
    id: 'tub-15',
    name: 'Pituca (Taro) Cocida',
    category: 'Tubérculos y Raíces',
    calories: 112,
    protein: 1.5,
    carbs: 26.5,
    fat: 0.2,
    fiber: 4.1,
    defaultServing: 100,
    servingUnit: 'porción',
    servingConversions: { porción: 100, taza: 132, cucharada: 9, '100g': 100 }
  },
  {
    id: 'tub-16',
    name: 'Sachapapa (Dioscorea)',
    category: 'Tubérculos y Raíces',
    calories: 118,
    protein: 1.5,
    carbs: 27.9,
    fat: 0.2,
    fiber: 4.0,
    defaultServing: 100,
    servingUnit: 'porción',
    servingConversions: { porción: 100, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // COMIDAS PERUANAS TÍPICAS (INS Tablas Peruanas de Composición de Alimentos)
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'comida-pe-1',
    name: 'Ceviche de Pescado',
    category: 'Comidas Peruanas',
    calories: 120,
    protein: 18.0,
    carbs: 8.0,
    fat: 2.0,
    fiber: 1.0,
    defaultServing: 200,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-2',
    name: 'Lomo Saltado',
    category: 'Comidas Peruanas',
    calories: 280,
    protein: 22.0,
    carbs: 18.0,
    fat: 12.0,
    fiber: 2.0,
    defaultServing: 300,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-3',
    name: 'Ají de Gallina',
    category: 'Comidas Peruanas',
    calories: 245,
    protein: 18.0,
    carbs: 20.0,
    fat: 10.0,
    fiber: 2.5,
    defaultServing: 300,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-4',
    name: 'Causa Limeña',
    category: 'Comidas Peruanas',
    calories: 195,
    protein: 8.0,
    carbs: 28.0,
    fat: 6.0,
    fiber: 2.0,
    defaultServing: 200,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-5',
    name: 'Arroz con Leche',
    category: 'Comidas Peruanas',
    calories: 175,
    protein: 4.0,
    carbs: 32.0,
    fat: 4.0,
    fiber: 0.3,
    defaultServing: 200,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-6',
    name: 'Sopa a la Minuta',
    category: 'Comidas Peruanas',
    calories: 130,
    protein: 10.0,
    carbs: 15.0,
    fat: 3.5,
    fiber: 1.5,
    defaultServing: 300,
    servingUnit: 'plato'
  },
  {
    id: 'comida-pe-7',
    name: 'Sancochado',
    category: 'Comidas Peruanas',
    calories: 160,
    protein: 12.0,
    carbs: 18.0,
    fat: 4.0,
    fiber: 3.0,
    defaultServing: 350,
    servingUnit: 'plato'
  },
  {
    id: 'comida-pe-8',
    name: 'Anticucho de Corazón',
    category: 'Comidas Peruanas',
    calories: 185,
    protein: 20.0,
    carbs: 5.0,
    fat: 9.0,
    fiber: 0.5,
    defaultServing: 150,
    servingUnit: '3 brochetas'
  },
  {
    id: 'comida-pe-9',
    name: 'Papa a la Huancaína',
    category: 'Comidas Peruanas',
    calories: 220,
    protein: 7.0,
    carbs: 25.0,
    fat: 10.0,
    fiber: 2.0,
    defaultServing: 200,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-10',
    name: 'Tacu Tacu',
    category: 'Comidas Peruanas',
    calories: 260,
    protein: 9.0,
    carbs: 42.0,
    fat: 6.0,
    fiber: 5.0,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-11',
    name: 'Arroz con Frijoles',
    category: 'Comidas Peruanas',
    calories: 185,
    protein: 7.5,
    carbs: 35.0,
    fat: 2.0,
    fiber: 5.0,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-12',
    name: 'Pollo a la Brasa (sin piel)',
    category: 'Comidas Peruanas',
    calories: 195,
    protein: 28.0,
    carbs: 0,
    fat: 9.0,
    fiber: 0,
    defaultServing: 150,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-13',
    name: 'Pollo a la Brasa (con piel)',
    category: 'Comidas Peruanas',
    calories: 250,
    protein: 26.0,
    carbs: 0,
    fat: 15.0,
    fiber: 0,
    defaultServing: 150,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-14',
    name: 'Caldo de Gallina',
    category: 'Comidas Peruanas',
    calories: 95,
    protein: 8.0,
    carbs: 10.0,
    fat: 2.5,
    fiber: 1.0,
    defaultServing: 350,
    servingUnit: 'plato'
  },
  {
    id: 'comida-pe-15',
    name: 'Sudado de Pescado',
    category: 'Comidas Peruanas',
    calories: 140,
    protein: 18.0,
    carbs: 8.0,
    fat: 4.0,
    fiber: 1.5,
    defaultServing: 300,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-16',
    name: 'Escabeche de Pollo',
    category: 'Comidas Peruanas',
    calories: 210,
    protein: 18.0,
    carbs: 12.0,
    fat: 9.0,
    fiber: 2.0,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-17',
    name: 'Sopa de Quinoa',
    category: 'Comidas Peruanas',
    calories: 110,
    protein: 5.5,
    carbs: 18.0,
    fat: 4.0,
    fiber: 2.5,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-18',
    name: 'Locro de Zapallo',
    category: 'Comidas Peruanas',
    calories: 145,
    protein: 5.0,
    carbs: 22.0,
    fat: 4.5,
    fiber: 3.0,
    defaultServing: 300,
    servingUnit: 'plato'
  },
  {
    id: 'comida-pe-19',
    name: 'Pepián de Trigo',
    category: 'Comidas Peruanas',
    calories: 175,
    protein: 8.0,
    carbs: 28.0,
    fat: 4.0,
    fiber: 3.5,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-20',
    name: 'Olluquito con Charqui',
    category: 'Comidas Peruanas',
    calories: 165,
    protein: 12.0,
    carbs: 18.0,
    fat: 5.0,
    fiber: 2.5,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-21',
    name: 'Carapulcra',
    category: 'Comidas Peruanas',
    calories: 230,
    protein: 14.0,
    carbs: 28.0,
    fat: 7.0,
    fiber: 4.0,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-22',
    name: 'Sopa Seca (Fideos con Pollo)',
    category: 'Comidas Peruanas',
    calories: 220,
    protein: 14.0,
    carbs: 30.0,
    fat: 5.0,
    fiber: 2.0,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-23',
    name: 'Mazamorra Morada',
    category: 'Comidas Peruanas',
    calories: 130,
    protein: 1.5,
    carbs: 30.0,
    fat: 0.5,
    fiber: 1.5,
    defaultServing: 200,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-24',
    name: 'Picarones',
    category: 'Comidas Peruanas',
    calories: 290,
    protein: 4.5,
    carbs: 42.0,
    fat: 12.0,
    fiber: 2.0,
    defaultServing: 100,
    servingUnit: '2 unidades'
  },
  {
    id: 'comida-pe-25',
    name: 'Chicharrón de Cerdo',
    category: 'Comidas Peruanas',
    calories: 540,
    protein: 28.0,
    carbs: 0,
    fat: 47.0,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g',
    servingConversions: { '100g': 100 }
  },
  {
    id: 'comida-pe-26',
    name: 'Arroz con Pato',
    category: 'Comidas Peruanas',
    calories: 245,
    protein: 16.0,
    carbs: 28.0,
    fat: 7.0,
    fiber: 1.5,
    defaultServing: 250,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-27',
    name: 'Pachamanca (Mixta)',
    category: 'Comidas Peruanas',
    calories: 280,
    protein: 20.0,
    carbs: 22.0,
    fat: 10.0,
    fiber: 3.0,
    defaultServing: 300,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-28',
    name: 'Cuy al Horno',
    category: 'Comidas Peruanas',
    calories: 200,
    protein: 24.0,
    carbs: 0,
    fat: 11.0,
    fiber: 0,
    defaultServing: 150,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-29',
    name: 'Tiradito de Pescado',
    category: 'Comidas Peruanas',
    calories: 105,
    protein: 16.0,
    carbs: 5.0,
    fat: 2.5,
    fiber: 0.5,
    defaultServing: 150,
    servingUnit: 'porción'
  },
  {
    id: 'comida-pe-30',
    name: 'Leche de Tigre',
    category: 'Comidas Peruanas',
    calories: 60,
    protein: 7.0,
    carbs: 5.0,
    fat: 1.0,
    fiber: 0.3,
    defaultServing: 150,
    servingUnit: 'vaso'
  },

  // ─────────────────────────────────────────────────────────────────────────
  // CEREALES ANDINOS Y SNACKS PERUANOS
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'snack-pe-1',
    name: 'Cancha Serrana (Maíz Tostado)',
    category: 'Snacks y Otros',
    calories: 408,
    protein: 10.0,
    carbs: 80.0,
    fat: 5.5,
    fiber: 7.3,
    defaultServing: 30,
    servingUnit: 'puñado',
    servingConversions: { puñado: 30, taza: 120, cucharada: 8, '100g': 100 }
  },
  {
    id: 'snack-pe-2',
    name: 'Chifles (Plátano Frito)',
    category: 'Snacks y Otros',
    calories: 490,
    protein: 2.5,
    carbs: 60.0,
    fat: 26.0,
    fiber: 3.5,
    defaultServing: 30,
    servingUnit: 'puñado',
    servingConversions: { puñado: 30, taza: 120, cucharada: 8, '100g': 100 }
  },
  {
    id: 'snack-pe-3',
    name: 'Tostadas de Quinoa',
    category: 'Snacks y Otros',
    calories: 380,
    protein: 12.0,
    carbs: 65.0,
    fat: 8.0,
    fiber: 6.0,
    defaultServing: 30,
    servingUnit: 'porción',
    servingConversions: { porción: 30, taza: 80, cucharada: 10, '100g': 100 }
  },
  {
    id: 'snack-pe-4',
    name: 'Galleta de Kiwicha',
    category: 'Snacks y Otros',
    calories: 390,
    protein: 10.0,
    carbs: 68.0,
    fat: 9.0,
    fiber: 5.0,
    defaultServing: 30,
    servingUnit: '3 galletas',
    servingConversions: { galleta: 10, '3 galletas': 30, '100g': 100 }
  },
  {
    id: 'snack-pe-5',
    name: 'Barrita de Quinoa y Miel',
    category: 'Snacks y Otros',
    calories: 350,
    protein: 8.0,
    carbs: 60.0,
    fat: 8.0,
    fiber: 4.0,
    defaultServing: 40,
    servingUnit: 'unidad',
    servingConversions: { unidad: 40, '100g': 100 }
  },
  {
    id: 'snack-1',
    name: 'Chips de Papa',
    category: 'Snacks y Otros',
    calories: 536,
    protein: 7,
    carbs: 53,
    fat: 35,
    fiber: 4.8,
    defaultServing: 28,
    servingUnit: 'porción (28g)',
    servingConversions: { 'porción (28g)': 28, taza: 28, '100g': 100 }
  },
  {
    id: 'snack-2',
    name: 'Palomitas de Maíz',
    category: 'Snacks y Otros',
    calories: 375,
    protein: 12,
    carbs: 74,
    fat: 4.5,
    fiber: 14,
    defaultServing: 28,
    servingUnit: 'taza',
    servingConversions: { taza: 28, '100g': 100 }
  },
  {
    id: 'snack-3',
    name: 'Chocolate Negro 70%',
    category: 'Snacks y Otros',
    calories: 598,
    protein: 7.8,
    carbs: 46,
    fat: 43,
    fiber: 10.9,
    defaultServing: 28,
    servingUnit: 'porción (28g)',
    servingConversions: { 'porción (28g)': 28, taza: 28, '100g': 100 }
  },
  {
    id: 'snack-4',
    name: 'Mantequilla de Maní',
    category: 'Snacks y Otros',
    calories: 588,
    protein: 25,
    carbs: 20,
    fat: 50,
    fiber: 6,
    defaultServing: 32,
    servingUnit: '2 cucharadas',
    servingConversions: { '2 cucharadas': 32, cucharada: 16, taza: 258, '100g': 100 }
  },
  {
    id: 'snack-5',
    name: 'Granola',
    category: 'Snacks y Otros',
    calories: 471,
    protein: 10,
    carbs: 64,
    fat: 20,
    fiber: 5.4,
    defaultServing: 60,
    servingUnit: 'taza',
    servingConversions: { taza: 60, '100g': 100 }
  },
  {
    id: 'snack-6',
    name: 'Hummus',
    category: 'Snacks y Otros',
    calories: 166,
    protein: 8,
    carbs: 14,
    fat: 10,
    fiber: 6,
    defaultServing: 100,
    servingUnit: '4 cucharadas',
    servingConversions: { '4 cucharadas': 100, taza: 200, cucharada: 10, '100g': 100 }
  },
  {
    id: 'snack-7',
    name: 'Guacamole',
    category: 'Snacks y Otros',
    calories: 150,
    protein: 2,
    carbs: 8,
    fat: 13,
    fiber: 5,
    defaultServing: 100,
    servingUnit: '4 cucharadas',
    servingConversions: { '4 cucharadas': 100, taza: 200, cucharada: 10, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // CONDIMENTOS Y SALSAS PERUANAS
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'cond-pe-1',
    name: 'Salsa Huancaína',
    category: 'Condimentos y Salsas',
    calories: 180,
    protein: 5.0,
    carbs: 8.0,
    fat: 14.0,
    fiber: 0.5,
    defaultServing: 50,
    servingUnit: '3 cucharadas',
    servingConversions: { '3 cucharadas': 50, cucharada: 15, '100g': 100 }
  },
  {
    id: 'cond-pe-2',
    name: 'Salsa de Ají Amarillo',
    category: 'Condimentos y Salsas',
    calories: 45,
    protein: 1.0,
    carbs: 8.0,
    fat: 1.0,
    fiber: 1.5,
    defaultServing: 30,
    servingUnit: '2 cucharadas',
    servingConversions: { '2 cucharadas': 30, cucharada: 10, '100g': 100 }
  },
  {
    id: 'cond-pe-3',
    name: 'Salsa de Soya',
    category: 'Condimentos y Salsas',
    calories: 53,
    protein: 8.1,
    carbs: 4.9,
    fat: 0.6,
    fiber: 0.8,
    defaultServing: 15,
    servingUnit: 'cucharada',
    servingConversions: { 'cucharada': 15, cucharadita: 5, '100g': 100 }
  },
  {
    id: 'cond-pe-4',
    name: 'Ketchup',
    category: 'Condimentos y Salsas',
    calories: 112,
    protein: 1.7,
    carbs: 27,
    fat: 0.2,
    fiber: 0.3,
    defaultServing: 17,
    servingUnit: 'cucharada',
    servingConversions: { 'cucharada': 17, cucharadita: 6, '100g': 100 }
  },
  {
    id: 'cond-pe-5',
    name: 'Mayonesa',
    category: 'Condimentos y Salsas',
    calories: 680,
    protein: 1,
    carbs: 0.6,
    fat: 75,
    fiber: 0,
    defaultServing: 15,
    servingUnit: 'cucharada',
    servingConversions: { 'cucharada': 15, cucharadita: 5, '100g': 100 }
  },
  {
    id: 'cond-pe-6',
    name: 'Mostaza',
    category: 'Condimentos y Salsas',
    calories: 66,
    protein: 4.4,
    carbs: 6.4,
    fat: 3.3,
    fiber: 3.2,
    defaultServing: 5,
    servingUnit: 'cucharadita',
    servingConversions: { 'cucharadita': 5, cucharada: 15, '100g': 100 }
  },
  {
    id: 'cond-pe-7',
    name: 'Miel de Abeja',
    category: 'Condimentos y Salsas',
    calories: 304,
    protein: 0.3,
    carbs: 82,
    fat: 0,
    fiber: 0.2,
    defaultServing: 21,
    servingUnit: 'cucharada',
    servingConversions: { 'cucharada': 21, cucharadita: 7, '100g': 100 }
  },
  {
    id: 'cond-pe-8',
    name: 'Azúcar Blanca',
    category: 'Condimentos y Salsas',
    calories: 387,
    protein: 0,
    carbs: 100,
    fat: 0,
    fiber: 0,
    defaultServing: 12,
    servingUnit: 'cucharada',
    servingConversions: { 'cucharada': 12, cucharadita: 4, '100g': 100 }
  },
  {
    id: 'cond-pe-9',
    name: 'Sal',
    category: 'Condimentos y Salsas',
    calories: 0,
    protein: 0,
    carbs: 0,
    fat: 0,
    fiber: 0,
    defaultServing: 6,
    servingUnit: 'cucharadita',
    servingConversions: { 'cucharadita': 6, cucharada: 18, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // DESAYUNOS Y LÁCTEOS PERUANOS
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'desayuno-pe-1',
    name: 'Avena con Leche',
    category: 'Desayunos',
    calories: 150,
    protein: 6.0,
    carbs: 25.0,
    fat: 3.5,
    fiber: 3.0,
    defaultServing: 250,
    servingUnit: 'taza'
  },
  {
    id: 'desayuno-pe-2',
    name: 'Quinoa con Leche',
    category: 'Desayunos',
    calories: 160,
    protein: 7.0,
    carbs: 26.0,
    fat: 3.5,
    fiber: 3.5,
    defaultServing: 250,
    servingUnit: 'taza'
  },
  {
    id: 'desayuno-pe-3',
    name: 'Pan con Queso Fresco',
    category: 'Desayunos',
    calories: 230,
    protein: 10.0,
    carbs: 30.0,
    fat: 8.0,
    fiber: 1.5,
    defaultServing: 100,
    servingUnit: 'porción'
  },
  {
    id: 'desayuno-pe-4',
    name: 'Pan con Palta',
    category: 'Desayunos',
    calories: 250,
    protein: 5.0,
    carbs: 30.0,
    fat: 13.0,
    fiber: 5.0,
    defaultServing: 120,
    servingUnit: 'porción'
  },
  {
    id: 'desayuno-pe-5',
    name: 'Tamal Verde',
    category: 'Desayunos',
    calories: 220,
    protein: 7.0,
    carbs: 32.0,
    fat: 7.0,
    fiber: 3.5,
    defaultServing: 120,
    servingUnit: 'unidad'
  },
  {
    id: 'desayuno-pe-6',
    name: 'Humitas Dulces',
    category: 'Desayunos',
    calories: 195,
    protein: 4.5,
    carbs: 35.0,
    fat: 5.0,
    fiber: 2.5,
    defaultServing: 100,
    servingUnit: 'unidad'
  },
  {
    id: 'desayuno-1',
    name: 'Tostadas con Mantequilla',
    category: 'Desayunos',
    calories: 315,
    protein: 8,
    carbs: 40,
    fat: 14,
    fiber: 2,
    defaultServing: 80,
    servingUnit: '2 rebanadas',
    servingConversions: { '2 rebanadas': 80, rebanada: 40, '100g': 100 }
  },
  {
    id: 'desayuno-2',
    name: 'Cereal con Leche',
    category: 'Desayunos',
    calories: 180,
    protein: 6,
    carbs: 35,
    fat: 2.5,
    fiber: 2,
    defaultServing: 200,
    servingUnit: 'taza'
  },
  {
    id: 'desayuno-3',
    name: 'Pancakes',
    category: 'Desayunos',
    calories: 227,
    protein: 6,
    carbs: 38,
    fat: 6,
    fiber: 1,
    defaultServing: 150,
    servingUnit: '3 unidades',
    servingConversions: { '3 unidades': 150, unidad: 50, '100g': 100 }
  },
  {
    id: 'desayuno-4',
    name: 'Huevos Revueltos',
    category: 'Desayunos',
    calories: 148,
    protein: 10,
    carbs: 1.6,
    fat: 11,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '2 huevos',
    servingConversions: { '2 huevos': 100, huevo: 50, '100g': 100 }
  },
  {
    id: 'desayuno-5',
    name: 'Yogur con Granola',
    category: 'Desayunos',
    calories: 230,
    protein: 8,
    carbs: 38,
    fat: 6,
    fiber: 2,
    defaultServing: 200,
    servingUnit: 'taza'
  },
  {
    id: 'desayuno-6',
    name: 'Smoothie de Frutas',
    category: 'Desayunos',
    calories: 120,
    protein: 2,
    carbs: 28,
    fat: 0.5,
    fiber: 3,
    defaultServing: 300,
    servingUnit: 'vaso',
    servingConversions: { 'vaso': 300, taza: 240, cucharada: 15, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // SUPPLEMENTOS Y PROTEÍNAS
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'supl-1',
    name: 'Whey Protein (Chocolate)',
    category: 'Suplementos',
    calories: 120,
    protein: 24,
    carbs: 5,
    fat: 2,
    fiber: 1,
    defaultServing: 30,
    servingUnit: 'scoop (30g)',
    servingConversions: { scoop: 30, '100g': 100 }
  },
  {
    id: 'supl-2',
    name: 'Whey Protein (Vainilla)',
    category: 'Suplementos',
    calories: 118,
    protein: 23,
    carbs: 5,
    fat: 2,
    fiber: 0.5,
    defaultServing: 30,
    servingUnit: 'scoop (30g)',
    servingConversions: { scoop: 30, '100g': 100 }
  },
  {
    id: 'supl-3',
    name: 'Caseína (Chocolate)',
    category: 'Suplementos',
    calories: 110,
    protein: 24,
    carbs: 4,
    fat: 1,
    fiber: 1,
    defaultServing: 33,
    servingUnit: 'scoop (33g)',
    servingConversions: { scoop: 33, '100g': 100 }
  },
  {
    id: 'supl-4',
    name: 'Proteína de Soya',
    category: 'Suplementos',
    calories: 95,
    protein: 22,
    carbs: 2,
    fat: 1,
    fiber: 0.5,
    defaultServing: 28,
    servingUnit: 'scoop (28g)',
    servingConversions: { scoop: 28, '100g': 100 }
  },
  {
    id: 'supl-5',
    name: 'Proteína de Guisante',
    category: 'Suplementos',
    calories: 100,
    protein: 21,
    carbs: 3,
    fat: 2,
    fiber: 1,
    defaultServing: 30,
    servingUnit: 'scoop (30g)',
    servingConversions: { scoop: 30, '100g': 100 }
  },
  {
    id: 'supl-6',
    name: 'Creatina Monohidrato',
    category: 'Suplementos',
    calories: 0,
    protein: 0,
    carbs: 0,
    fat: 0,
    fiber: 0,
    defaultServing: 5,
    servingUnit: 'cucharadita (5g)',
    servingConversions: { 'cucharadita (5g)': 5, '100g': 100 }
  },
  {
    id: 'supl-7',
    name: 'BCAA en Polvo',
    category: 'Suplementos',
    calories: 20,
    protein: 0,
    carbs: 3,
    fat: 0,
    fiber: 0,
    defaultServing: 10,
    servingUnit: 'scoop (10g)',
    servingConversions: { scoop: 10, '100g': 100 }
  },
  {
    id: 'supl-8',
    name: 'Gainers / Mass Gainer',
    category: 'Suplementos',
    calories: 400,
    protein: 25,
    carbs: 65,
    fat: 5,
    fiber: 2,
    defaultServing: 150,
    servingUnit: '2 scoops (150g)',
    servingConversions: { '2 scoops (150g)': 150, scoop: 75, '100g': 100 }
  },
  {
    id: 'supl-9',
    name: 'Pre-Workout (Polvo)',
    category: 'Suplementos',
    calories: 15,
    protein: 0,
    carbs: 3,
    fat: 0,
    fiber: 0,
    defaultServing: 10,
    servingUnit: 'scoop (10g)',
    servingConversions: { scoop: 10, '100g': 100 }
  },
  {
    id: 'supl-10',
    name: 'Colágeno Hidrolizado',
    category: 'Suplementos',
    calories: 35,
    protein: 9,
    carbs: 0,
    fat: 0,
    fiber: 0,
    defaultServing: 10,
    servingUnit: 'cucharada (10g)',
    servingConversions: { 'cucharada (10g)': 10, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // FRUTOS SECOS Y SEMILLAS
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'nuts-1',
    name: 'Almendras',
    category: 'Frutos Secos y Semillas',
    calories: 579,
    protein: 21,
    carbs: 22,
    fat: 50,
    fiber: 12.5,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 143, cucharada: 9, '100g': 100 }
  },
  {
    id: 'nuts-2',
    name: 'Nueces',
    category: 'Frutos Secos y Semillas',
    calories: 654,
    protein: 15,
    carbs: 14,
    fat: 65,
    fiber: 6.7,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 117, cucharada: 7, '100g': 100 }
  },
  {
    id: 'nuts-3',
    name: 'Maní (Cacahuetes)',
    category: 'Frutos Secos y Semillas',
    calories: 567,
    protein: 26,
    carbs: 16,
    fat: 49,
    fiber: 8.5,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 129, cucharada: 9, '100g': 100 }
  },
  {
    id: 'nuts-4',
    name: 'Mantequilla de Maní',
    category: 'Frutos Secos y Semillas',
    calories: 588,
    protein: 25,
    carbs: 20,
    fat: 50,
    fiber: 6,
    defaultServing: 32,
    servingUnit: '2 cucharadas',
    servingConversions: { '2 cucharadas': 32, cucharada: 16, taza: 258, '100g': 100 }
  },
  {
    id: 'nuts-5',
    name: 'Semillas de Chía',
    category: 'Frutos Secos y Semillas',
    calories: 486,
    protein: 17,
    carbs: 42,
    fat: 31,
    fiber: 34,
    defaultServing: 28,
    servingUnit: '2 cucharadas',
    servingConversions: { '2 cucharadas': 28, cucharada: 14, taza: 160, '100g': 100 }
  },
  {
    id: 'nuts-6',
    name: 'Semillas de Linaza',
    category: 'Frutos Secos y Semillas',
    calories: 534,
    protein: 18,
    carbs: 29,
    fat: 42,
    fiber: 27,
    defaultServing: 14,
    servingUnit: 'cucharada',
    servingConversions: { cucharada: 14, cucharadita: 5, taza: 149, '100g': 100 }
  },
  {
    id: 'nuts-7',
    name: 'Semillas de Girasol',
    category: 'Frutos Secos y Semillas',
    calories: 584,
    protein: 21,
    carbs: 20,
    fat: 51,
    fiber: 8.6,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 140, cucharada: 9, '100g': 100 }
  },
  {
    id: 'nuts-8',
    name: 'Semillas de Calabaza',
    category: 'Frutos Secos y Semillas',
    calories: 559,
    protein: 30,
    carbs: 11,
    fat: 49,
    fiber: 6,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 129, cucharada: 9, '100g': 100 }
  },
  {
    id: 'nuts-9',
    name: 'Pistachos',
    category: 'Frutos Secos y Semillas',
    calories: 560,
    protein: 20,
    carbs: 28,
    fat: 45,
    fiber: 10,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 140, cucharada: 9, '100g': 100 }
  },
  {
    id: 'nuts-10',
    name: 'Anacardos / Castañas de Cajú',
    category: 'Frutos Secos y Semillas',
    calories: 553,
    protein: 18,
    carbs: 30,
    fat: 44,
    fiber: 3.3,
    defaultServing: 28,
    servingUnit: 'puñado (28g)',
    servingConversions: { puñado: 28, taza: 109, cucharada: 7, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // COMIDA RÁPIDA Y RESTAURANTES
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'fastfood-1',
    name: 'Hamburguesa Simple',
    category: 'Comida Rápida',
    calories: 295,
    protein: 17,
    carbs: 24,
    fat: 14,
    fiber: 1,
    defaultServing: 130,
    servingUnit: 'unidad',
    servingConversions: { unidad: 130, '100g': 100 }
  },
  {
    id: 'fastfood-2',
    name: 'Hamburguesa Doble con Queso',
    category: 'Comida Rápida',
    calories: 490,
    protein: 30,
    carbs: 35,
    fat: 26,
    fiber: 2,
    defaultServing: 220,
    servingUnit: 'unidad',
    servingConversions: { unidad: 220, '100g': 100 }
  },
  {
    id: 'fastfood-3',
    name: 'Papas Fritas (porción mediana)',
    category: 'Comida Rápida',
    calories: 365,
    protein: 4,
    carbs: 48,
    fat: 17,
    fiber: 4,
    defaultServing: 117,
    servingUnit: 'porción mediana',
    servingConversions: { 'porción mediana': 117, taza: 160, cucharada: 10, '100g': 100 }
  },
  {
    id: 'fastfood-4',
    name: 'Pizza Margarita (rebanada)',
    category: 'Comida Rápida',
    calories: 266,
    protein: 11,
    carbs: 33,
    fat: 10,
    fiber: 2,
    defaultServing: 107,
    servingUnit: 'rebanada',
    servingConversions: { rebanada: 107, '100g': 100 }
  },
  {
    id: 'fastfood-5',
    name: 'Hot Dog',
    category: 'Comida Rápida',
    calories: 290,
    protein: 11,
    carbs: 23,
    fat: 17,
    fiber: 1,
    defaultServing: 120,
    servingUnit: 'unidad',
    servingConversions: { unidad: 120, '100g': 100 }
  },
  {
    id: 'fastfood-6',
    name: 'Pollo Frito (muslo)',
    category: 'Comida Rápida',
    calories: 284,
    protein: 22,
    carbs: 10,
    fat: 18,
    fiber: 0.5,
    defaultServing: 120,
    servingUnit: 'muslo',
    servingConversions: { muslo: 120, '100g': 100 }
  },
  {
    id: 'fastfood-7',
    name: 'Wrap de Pollo',
    category: 'Comida Rápida',
    calories: 310,
    protein: 25,
    carbs: 30,
    fat: 10,
    fiber: 3,
    defaultServing: 200,
    servingUnit: 'unidad',
    servingConversions: { unidad: 200, '100g': 100 }
  },
  {
    id: 'fastfood-8',
    name: 'Nuggets de Pollo (6 piezas)',
    category: 'Comida Rápida',
    calories: 280,
    protein: 15,
    carbs: 18,
    fat: 17,
    fiber: 1,
    defaultServing: 100,
    servingUnit: '6 piezas',
    servingConversions: { '6 piezas': 100, pieza: 16, '100g': 100 }
  },
  {
    id: 'fastfood-9',
    name: 'Burrito de Pollo',
    category: 'Comida Rápida',
    calories: 450,
    protein: 28,
    carbs: 50,
    fat: 15,
    fiber: 5,
    defaultServing: 250,
    servingUnit: 'unidad',
    servingConversions: { unidad: 250, '100g': 100 }
  },
  {
    id: 'fastfood-10',
    name: 'Tacos (2 unidades)',
    category: 'Comida Rápida',
    calories: 370,
    protein: 20,
    carbs: 38,
    fat: 16,
    fiber: 4,
    defaultServing: 180,
    servingUnit: '2 tacos',
    servingConversions: { '2 tacos': 180, taco: 90, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // BEBIDAS Y JUGOS
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'beb-1',
    name: 'Jugo de Naranja Natural',
    category: 'Bebidas',
    calories: 45,
    protein: 0.7,
    carbs: 10,
    fat: 0.2,
    fiber: 0.2,
    defaultServing: 240,
    servingUnit: 'vaso (240ml)',
    servingConversions: { vaso: 240, '240ml': 240, '100g': 100 }
  },
  {
    id: 'beb-2',
    name: 'Leche Entera',
    category: 'Bebidas',
    calories: 61,
    protein: 3.2,
    carbs: 4.8,
    fat: 3.3,
    fiber: 0,
    defaultServing: 240,
    servingUnit: 'vaso (240ml)',
    servingConversions: { vaso: 240, '240ml': 240, '100g': 100 }
  },
  {
    id: 'beb-3',
    name: 'Leche Descremada',
    category: 'Bebidas',
    calories: 34,
    protein: 3.4,
    carbs: 5,
    fat: 0.1,
    fiber: 0,
    defaultServing: 240,
    servingUnit: 'vaso (240ml)',
    servingConversions: { vaso: 240, '240ml': 240, '100g': 100 }
  },
  {
    id: 'beb-4',
    name: 'Leche de Almendras',
    category: 'Bebidas',
    calories: 17,
    protein: 0.6,
    carbs: 1.5,
    fat: 1.1,
    fiber: 0.3,
    defaultServing: 240,
    servingUnit: 'vaso (240ml)',
    servingConversions: { vaso: 240, '240ml': 240, '100g': 100 }
  },
  {
    id: 'beb-5',
    name: 'Batido de Proteína',
    category: 'Bebidas',
    calories: 160,
    protein: 30,
    carbs: 8,
    fat: 3,
    fiber: 1,
    defaultServing: 330,
    servingUnit: 'botella (330ml)',
    servingConversions: { botella: 330, vaso: 240, '100g': 100 }
  },
  {
    id: 'beb-6',
    name: 'Chicharrón de Cerdo',
    category: 'Bebidas',
    calories: 540,
    protein: 28.0,
    carbs: 0,
    fat: 47.0,
    fiber: 0,
    defaultServing: 100,
    servingUnit: '100g',
    servingConversions: { '100g': 100 }
  },
  {
    id: 'beb-7',
    name: 'Arroz con Leche',
    category: 'Bebidas',
    calories: 130,
    protein: 3.5,
    carbs: 22.0,
    fat: 0.9,
    fiber: 1.8,
    defaultServing: 140,
    servingUnit: 'taza',
    servingConversions: { taza: 140, '100g': 100 }
  },
  {
    id: 'beb-8',
    name: 'Maca en Bebida',
    category: 'Bebidas',
    calories: 30,
    protein: 0.8,
    carbs: 6.5,
    fat: 0.2,
    fiber: 0.5,
    defaultServing: 240,
    servingUnit: 'vaso',
    servingConversions: { vaso: 240, taza: 240, '100g': 100 }
  },
  {
    id: 'beb-9',
    name: 'Inca Kola',
    category: 'Bebidas',
    calories: 43,
    protein: 0,
    carbs: 10.8,
    fat: 0,
    fiber: 0,
    defaultServing: 355,
    servingUnit: 'lata (355ml)',
    servingConversions: { lata: 355, vaso: 240, '100g': 100 }
  },
  {
    id: 'beb-10',
    name: 'Pepián de Trigo',
    category: 'Bebidas',
    calories: 175,
    protein: 8.0,
    carbs: 28.0,
    fat: 4.0,
    fiber: 3.5,
    defaultServing: 240,
    servingUnit: 'taza',
    servingConversions: { taza: 240, '100g': 100 }
  },
  {
    id: 'beb-11',
    name: 'Mantequilla',
    category: 'Bebidas',
    calories: 717,
    protein: 0.9,
    carbs: 0.1,
    fat: 81,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada',
    servingConversions: { cucharada: 14, cucharadita: 5, '100g': 100 }
  },
  {
    id: 'beb-12',
    name: 'Crema de Leche',
    category: 'Bebidas',
    calories: 340,
    protein: 2.1,
    carbs: 2.8,
    fat: 36,
    fiber: 0,
    defaultServing: 30,
    servingUnit: '2 cucharadas',
    servingConversions: { '2 cucharadas': 30, cucharada: 15, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // LÁCTEOS ADICIONALES
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'lacteo-1',
    name: 'Yogur Griego Natural',
    category: 'Lácteos',
    calories: 59,
    protein: 10,
    carbs: 3.6,
    fat: 0.4,
    fiber: 0,
    defaultServing: 170,
    servingUnit: 'taza',
    servingConversions: { taza: 170, 'media taza': 85, '100g': 100 }
  },
  {
    id: 'lacteo-2',
    name: 'Yogur Natural (entero)',
    category: 'Lácteos',
    calories: 61,
    protein: 3.5,
    carbs: 4.7,
    fat: 3.3,
    fiber: 0,
    defaultServing: 170,
    servingUnit: 'taza',
    servingConversions: { taza: 170, 'media taza': 85, '100g': 100 }
  },
  {
    id: 'lacteo-3',
    name: 'Queso Mozzarella',
    category: 'Lácteos',
    calories: 280,
    protein: 28,
    carbs: 2.2,
    fat: 17,
    fiber: 0,
    defaultServing: 30,
    servingUnit: 'rebanada',
    servingConversions: { rebanada: 30, '100g': 100 }
  },
  {
    id: 'lacteo-4',
    name: 'Queso Cheddar',
    category: 'Lácteos',
    calories: 403,
    protein: 25,
    carbs: 1.3,
    fat: 33,
    fiber: 0,
    defaultServing: 28,
    servingUnit: 'rebanada',
    servingConversions: { rebanada: 28, '100g': 100 }
  },
  {
    id: 'lacteo-5',
    name: 'Queso Cottage',
    category: 'Lácteos',
    calories: 98,
    protein: 11,
    carbs: 3.4,
    fat: 4.3,
    fiber: 0,
    defaultServing: 113,
    servingUnit: 'taza',
    servingConversions: { taza: 113, '100g': 100 }
  },
  {
    id: 'lacteo-6',
    name: 'Requesón / Ricotta',
    category: 'Lácteos',
    calories: 174,
    protein: 11,
    carbs: 3,
    fat: 13,
    fiber: 0,
    defaultServing: 124,
    servingUnit: 'taza',
    servingConversions: { taza: 124, '100g': 100 }
  },
  {
    id: 'lacteo-7',
    name: 'Mantequilla',
    category: 'Lácteos',
    calories: 717,
    protein: 0.9,
    carbs: 0.1,
    fat: 81,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada',
    servingConversions: { cucharada: 14, cucharadita: 5, '100g': 100 }
  },
  {
    id: 'lacteo-8',
    name: 'Crema de Leche',
    category: 'Lácteos',
    calories: 340,
    protein: 2.1,
    carbs: 2.8,
    fat: 36,
    fiber: 0,
    defaultServing: 30,
    servingUnit: '2 cucharadas',
    servingConversions: { '2 cucharadas': 30, cucharada: 15, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // COMIDAS LATINAS / COLOMBIANAS
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'latam-1',
    name: 'Bandeja Paisa',
    category: 'Comidas Latinas',
    calories: 1200,
    protein: 65,
    carbs: 110,
    fat: 50,
    fiber: 12,
    defaultServing: 600,
    servingUnit: 'plato',
    servingConversions: { plato: 600, taza: 400, '100g': 100 }
  },
  {
    id: 'latam-2',
    name: 'Arepas de Maíz',
    category: 'Comidas Latinas',
    calories: 200,
    protein: 4,
    carbs: 38,
    fat: 4,
    fiber: 2,
    defaultServing: 100,
    servingUnit: 'unidad',
    servingConversions: { unidad: 100, '100g': 100 }
  },
  {
    id: 'latam-3',
    name: 'Arepa con Queso',
    category: 'Comidas Latinas',
    calories: 280,
    protein: 10,
    carbs: 38,
    fat: 10,
    fiber: 2,
    defaultServing: 130,
    servingUnit: 'unidad',
    servingConversions: { unidad: 130, '100g': 100 }
  },
  {
    id: 'latam-4',
    name: 'Empanadas de Carne',
    category: 'Comidas Latinas',
    calories: 250,
    protein: 10,
    carbs: 28,
    fat: 12,
    fiber: 1.5,
    defaultServing: 100,
    servingUnit: 'unidad',
    servingConversions: { unidad: 100, '100g': 100 }
  },
  {
    id: 'latam-5',
    name: 'Sancocho de Pollo',
    category: 'Comidas Latinas',
    calories: 220,
    protein: 18,
    carbs: 22,
    fat: 6,
    fiber: 3,
    defaultServing: 400,
    servingUnit: 'plato',
    servingConversions: { plato: 400, tazón: 300, '100g': 100 }
  },
  {
    id: 'latam-6',
    name: 'Frijoles Rojos Cocinados',
    category: 'Comidas Latinas',
    calories: 127,
    protein: 8.7,
    carbs: 23,
    fat: 0.5,
    fiber: 6.4,
    defaultServing: 180,
    servingUnit: 'taza',
    servingConversions: { taza: 180, '100g': 100 }
  },
  {
    id: 'latam-7',
    name: 'Arroz con Leche',
    category: 'Comidas Latinas',
    calories: 130,
    protein: 3,
    carbs: 25,
    fat: 2.5,
    fiber: 0.3,
    defaultServing: 200,
    servingUnit: 'taza',
    servingConversions: { taza: 200, '100g': 100 }
  },
  {
    id: 'latam-8',
    name: 'Chicharrón de Cerdo',
    category: 'Comidas Latinas',
    calories: 544,
    protein: 31,
    carbs: 0,
    fat: 47,
    fiber: 0,
    defaultServing: 50,
    servingUnit: 'porción',
    servingConversions: { porción: 50, '100g': 100 }
  },
  {
    id: 'latam-9',
    name: 'Patacones / Tostones',
    category: 'Comidas Latinas',
    calories: 180,
    protein: 1.5,
    carbs: 30,
    fat: 6,
    fiber: 2,
    defaultServing: 100,
    servingUnit: 'porción',
    servingConversions: { porción: 100, taza: 140, '100g': 100 }
  },
  {
    id: 'latam-10',
    name: 'Caldo de Costilla',
    category: 'Comidas Latinas',
    calories: 150,
    protein: 12,
    carbs: 10,
    fat: 6,
    fiber: 1,
    defaultServing: 400,
    servingUnit: 'plato',
    servingConversions: { plato: 400, tazón: 300, '100g': 100 }
  },
  {
    id: 'latam-11',
    name: 'Mondongo',
    category: 'Comidas Latinas',
    calories: 130,
    protein: 14,
    carbs: 8,
    fat: 5,
    fiber: 2,
    defaultServing: 350,
    servingUnit: 'plato',
    servingConversions: { plato: 350, tazón: 240, '100g': 100 }
  },
  {
    id: 'latam-12',
    name: 'Mazamorra Morada',
    category: 'Comidas Latinas',
    calories: 120,
    protein: 1.5,
    carbs: 28,
    fat: 0.5,
    fiber: 2,
    defaultServing: 250,
    servingUnit: 'taza',
    servingConversions: { taza: 250, '100g': 100 }
  },
  {
    id: 'latam-13',
    name: 'Lomo Saltado',
    category: 'Comidas Latinas',
    calories: 380,
    protein: 28,
    carbs: 30,
    fat: 16,
    fiber: 3,
    defaultServing: 350,
    servingUnit: 'plato',
    servingConversions: { plato: 350, tazón: 240, '100g': 100 }
  },
  {
    id: 'latam-14',
    name: 'Ceviche de Pescado',
    category: 'Comidas Latinas',
    calories: 130,
    protein: 18,
    carbs: 8,
    fat: 3,
    fiber: 1.5,
    defaultServing: 250,
    servingUnit: 'plato',
    servingConversions: { plato: 250, tazón: 175, '100g': 100 }
  },
  {
    id: 'latam-15',
    name: 'Ají de Gallina',
    category: 'Comidas Latinas',
    calories: 280,
    protein: 22,
    carbs: 18,
    fat: 13,
    fiber: 2,
    defaultServing: 300,
    servingUnit: 'plato',
    servingConversions: { plato: 300, tazón: 200, '100g': 100 }
  },
  {
    id: 'latam-16',
    name: 'Tamales',
    category: 'Comidas Latinas',
    calories: 285,
    protein: 8,
    carbs: 38,
    fat: 11,
    fiber: 5,
    defaultServing: 100,
    servingUnit: 'unidad',
    servingConversions: { unidad: 100, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // SNACKS Y BARRAS ENERGÉTICAS
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'snack-1',
    name: 'Barra de Proteína',
    category: 'Snacks',
    calories: 200,
    protein: 20,
    carbs: 22,
    fat: 7,
    fiber: 3,
    defaultServing: 60,
    servingUnit: 'barra',
    servingConversions: { barra: 60, '100g': 100 }
  },
  {
    id: 'snack-2',
    name: 'Barra de Granola',
    category: 'Snacks',
    calories: 190,
    protein: 4,
    carbs: 30,
    fat: 7,
    fiber: 2,
    defaultServing: 47,
    servingUnit: 'barra',
    servingConversions: { barra: 47, '100g': 100 }
  },
  {
    id: 'snack-3',
    name: 'Chips de Maíz / Tostitos',
    category: 'Snacks',
    calories: 480,
    protein: 7,
    carbs: 65,
    fat: 22,
    fiber: 4,
    defaultServing: 28,
    servingUnit: 'porción (28g)',
    servingConversions: { 'porción (28g)': 28, taza: 28, '100g': 100 }
  },
  {
    id: 'snack-4',
    name: 'Palomitas de Maíz (sin mantequilla)',
    category: 'Snacks',
    calories: 375,
    protein: 11,
    carbs: 74,
    fat: 4.5,
    fiber: 14,
    defaultServing: 28,
    servingUnit: 'taza',
    servingConversions: { taza: 28, '100g': 100 }
  },
  {
    id: 'snack-5',
    name: 'Galletas de Arroz',
    category: 'Snacks',
    calories: 387,
    protein: 8,
    carbs: 81,
    fat: 3,
    fiber: 1.5,
    defaultServing: 18,
    servingUnit: '2 galletas',
    servingConversions: { '2 galletas': 18, galleta: 10, '100g': 100 }
  },
  {
    id: 'snack-6',
    name: 'Chocolate Negro (70%)',
    category: 'Snacks',
    calories: 598,
    protein: 7.8,
    carbs: 46,
    fat: 43,
    fiber: 10.9,
    defaultServing: 30,
    servingUnit: 'porción (30g)',
    servingConversions: { 'porción (30g)': 30, cucharadita: 10, cucharada: 30, '100g': 100 }
  },
  {
    id: 'snack-7',
    name: 'Chocolate con Leche',
    category: 'Snacks',
    calories: 535,
    protein: 7.7,
    carbs: 60,
    fat: 30,
    fiber: 3.4,
    defaultServing: 30,
    servingUnit: 'porción (30g)',
    servingConversions: { 'porción (30g)': 30, cucharadita: 10, cucharada: 30, '100g': 100 }
  },
  {
    id: 'snack-8',
    name: 'Gelatina (sin azúcar)',
    category: 'Snacks',
    calories: 10,
    protein: 1,
    carbs: 1,
    fat: 0,
    fiber: 0,
    defaultServing: 120,
    servingUnit: 'taza',
    servingConversions: { taza: 120, '100g': 100 }
  },

  // ─────────────────────────────────────────────────────────────────────────
  // ACEITES Y GRASAS
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: 'aceite-1',
    name: 'Aceite de Oliva Extra Virgen',
    category: 'Aceites y Grasas',
    calories: 884,
    protein: 0,
    carbs: 0,
    fat: 100,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada',
    servingConversions: { cucharada: 14, cucharadita: 5, taza: 216, '100g': 100 }
  },
  {
    id: 'aceite-2',
    name: 'Aceite de Coco',
    category: 'Aceites y Grasas',
    calories: 862,
    protein: 0,
    carbs: 0,
    fat: 100,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada',
    servingConversions: { cucharada: 14, cucharadita: 5, taza: 216, '100g': 100 }
  },
  {
    id: 'aceite-3',
    name: 'Aceite de Girasol',
    category: 'Aceites y Grasas',
    calories: 884,
    protein: 0,
    carbs: 0,
    fat: 100,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada',
    servingConversions: { cucharada: 14, cucharadita: 5, taza: 216, '100g': 100 }
  },
  {
    id: 'aceite-4',
    name: 'Aceite Vegetal / Girasol',
    category: 'Aceites y Grasas',
    calories: 884,
    protein: 0,
    carbs: 0,
    fat: 100,
    fiber: 0,
    defaultServing: 14,
    servingUnit: 'cucharada',
    servingConversions: { cucharada: 14, cucharadita: 5, taza: 216, '100g': 100 }
  }
];

// ─── EXTENDED MINSA DATABASE ADDITIONS ───────────────────────────────────────
// All values per 100g. Source: Tablas Peruanas de Composición de Alimentos (INS/MINSA, 2017)
// servingConversions: grams per common serving unit

export const minsaExtendedFoods = [

  // ══════════════════════════════════════════════════════════════════
  // TUBÉRCULOS Y RAÍCES
  // ══════════════════════════════════════════════════════════════════
  { id: 'tub-1', name: 'Papa Blanca Cocida', category: 'Tubérculos y Raíces', calories: 77, protein: 2.0, carbs: 17.5, fat: 0.1, fiber: 1.8, defaultServing: 150, servingUnit: 'unidad mediana', servingConversions: { unidad: 150, taza: 150, '100g': 100 } },
  { id: 'tub-2', name: 'Papa Amarilla Cocida', category: 'Tubérculos y Raíces', calories: 82, protein: 2.1, carbs: 18.5, fat: 0.1, fiber: 1.6, defaultServing: 150, servingUnit: 'unidad mediana', servingConversions: { unidad: 150, taza: 150, '100g': 100 } },
  { id: 'tub-3', name: 'Papa Huayro', category: 'Tubérculos y Raíces', calories: 79, protein: 2.0, carbs: 17.8, fat: 0.1, fiber: 1.9, defaultServing: 150, servingUnit: 'unidad mediana', servingConversions: { unidad: 150, taza: 150, '100g': 100 } },
  { id: 'tub-4', name: 'Papa Negra (Tomasa)', category: 'Tubérculos y Raíces', calories: 80, protein: 2.1, carbs: 18.0, fat: 0.1, fiber: 2.0, defaultServing: 150, servingUnit: 'unidad mediana', servingConversions: { unidad: 150, taza: 150, '100g': 100 } },
  { id: 'tub-5', name: 'Chuño (Papa Deshidratada)', category: 'Tubérculos y Raíces', calories: 330, protein: 7.0, carbs: 75.0, fat: 0.5, fiber: 8.0, defaultServing: 50, servingUnit: 'porción', servingConversions: { porción: 50, cucharada: 15, '100g': 100 } },
  { id: 'tub-6', name: 'Moraya (Chuño Blanco)', category: 'Tubérculos y Raíces', calories: 320, protein: 6.5, carbs: 73.0, fat: 0.4, fiber: 7.5, defaultServing: 50, servingUnit: 'porción', servingConversions: { porción: 50, cucharada: 15, '100g': 100 } },
  { id: 'tub-7', name: 'Camote Amarillo Cocido', category: 'Tubérculos y Raíces', calories: 86, protein: 1.6, carbs: 20.1, fat: 0.1, fiber: 3.0, defaultServing: 130, servingUnit: 'unidad mediana', servingConversions: { unidad: 130, taza: 200, '100g': 100 } },
  { id: 'tub-8', name: 'Camote Morado', category: 'Tubérculos y Raíces', calories: 90, protein: 1.6, carbs: 21.0, fat: 0.1, fiber: 3.3, defaultServing: 130, servingUnit: 'unidad mediana', servingConversions: { unidad: 130, taza: 200, '100g': 100 } },
  { id: 'tub-9', name: 'Yuca Cocida', category: 'Tubérculos y Raíces', calories: 160, protein: 1.4, carbs: 38.1, fat: 0.3, fiber: 1.8, defaultServing: 100, servingUnit: 'trozo', servingConversions: { trozo: 100, taza: 206, '100g': 100 } },
  { id: 'tub-10', name: 'Oca Cocida', category: 'Tubérculos y Raíces', calories: 61, protein: 1.0, carbs: 14.0, fat: 0.1, fiber: 1.5, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 150, '100g': 100 } },
  { id: 'tub-11', name: 'Olluco Cocido', category: 'Tubérculos y Raíces', calories: 57, protein: 1.1, carbs: 13.0, fat: 0.1, fiber: 1.2, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 150, '100g': 100 } },
  { id: 'tub-12', name: 'Mashua (Isaño) Cocida', category: 'Tubérculos y Raíces', calories: 52, protein: 1.5, carbs: 11.5, fat: 0.1, fiber: 1.8, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 150, '100g': 100 } },
  { id: 'tub-13', name: 'Arracacha Cocida', category: 'Tubérculos y Raíces', calories: 95, protein: 1.0, carbs: 22.5, fat: 0.3, fiber: 2.0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 150, '100g': 100 } },
  { id: 'tub-14', name: 'Maca en Polvo', category: 'Tubérculos y Raíces', calories: 325, protein: 10.2, carbs: 65.0, fat: 2.2, fiber: 8.5, defaultServing: 10, servingUnit: 'cucharadita', servingConversions: { cucharadita: 5, cucharada: 10, '100g': 100 } },
  { id: 'tub-15', name: 'Papa Seca (Deshidratada)', category: 'Tubérculos y Raíces', calories: 340, protein: 7.5, carbs: 78.0, fat: 0.5, fiber: 6.5, defaultServing: 50, servingUnit: 'porción', servingConversions: { porción: 50, '100g': 100 } },
  { id: 'tub-16', name: 'Pituca (Taro) Cocida', category: 'Tubérculos y Raíces', calories: 112, protein: 1.5, carbs: 26.5, fat: 0.2, fiber: 4.1, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 132, '100g': 100 } },
  { id: 'tub-17', name: 'Sachapapa (Dioscorea)', category: 'Tubérculos y Raíces', calories: 118, protein: 1.5, carbs: 27.9, fat: 0.2, fiber: 4.0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // CEREALES Y DERIVADOS (adicionales)
  // ══════════════════════════════════════════════════════════════════
  { id: 'cer-1', name: 'Arroz Crudo', category: 'Granos y Cereales', calories: 365, protein: 7.1, carbs: 80.4, fat: 0.7, fiber: 1.3, defaultServing: 45, servingUnit: '¼ taza crudo', servingConversions: { 'cuarto taza': 45, taza: 185, cucharada: 12, '100g': 100 } },
  { id: 'cer-2', name: 'Arroz Parboiled', category: 'Granos y Cereales', calories: 360, protein: 7.5, carbs: 79.0, fat: 0.6, fiber: 1.4, defaultServing: 45, servingUnit: '¼ taza crudo', servingConversions: { 'cuarto taza': 45, taza: 185, cucharada: 12, '100g': 100 } },
  { id: 'cer-3', name: 'Harina de Trigo', category: 'Granos y Cereales', calories: 364, protein: 10.3, carbs: 76.3, fat: 1.0, fiber: 2.7, defaultServing: 30, servingUnit: '¼ taza', servingConversions: { 'cuarto taza': 30, taza: 120, cucharada: 8, '100g': 100 } },
  { id: 'cer-4', name: 'Harina de Maíz', category: 'Granos y Cereales', calories: 362, protein: 8.1, carbs: 76.8, fat: 3.6, fiber: 7.3, defaultServing: 30, servingUnit: '¼ taza', servingConversions: { 'cuarto taza': 30, taza: 120, cucharada: 8, '100g': 100 } },
  { id: 'cer-5', name: 'Harina de Quinoa', category: 'Granos y Cereales', calories: 368, protein: 14.1, carbs: 64.2, fat: 6.1, fiber: 7.0, defaultServing: 30, servingUnit: '¼ taza', servingConversions: { 'cuarto taza': 30, taza: 120, cucharada: 8, '100g': 100 } },
  { id: 'cer-6', name: 'Harina de Kiwicha', category: 'Granos y Cereales', calories: 374, protein: 14.5, carbs: 63.1, fat: 7.2, fiber: 6.7, defaultServing: 30, servingUnit: '¼ taza', servingConversions: { 'cuarto taza': 30, taza: 120, cucharada: 8, '100g': 100 } },
  { id: 'cer-7', name: 'Harina de Cañihua', category: 'Granos y Cereales', calories: 343, protein: 15.7, carbs: 57.0, fat: 5.9, fiber: 9.8, defaultServing: 30, servingUnit: '¼ taza', servingConversions: { 'cuarto taza': 30, taza: 120, cucharada: 8, '100g': 100 } },
  { id: 'cer-8', name: 'Cañihua Cruda', category: 'Granos y Cereales', calories: 343, protein: 15.7, carbs: 57.0, fat: 5.9, fiber: 9.8, defaultServing: 40, servingUnit: '¼ taza', servingConversions: { 'cuarto taza': 40, taza: 160, cucharada: 10, '100g': 100 } },
  { id: 'cer-9', name: 'Kiwicha Cocida', category: 'Granos y Cereales', calories: 102, protein: 3.8, carbs: 18.8, fat: 1.6, fiber: 2.1, defaultServing: 185, servingUnit: 'taza', servingConversions: { taza: 185, 'media taza': 93, cucharada: 12, '100g': 100 } },
  { id: 'cer-10', name: 'Trigo Sarraceno (Kasha)', category: 'Granos y Cereales', calories: 343, protein: 13.3, carbs: 71.5, fat: 3.4, fiber: 10.0, defaultServing: 40, servingUnit: '¼ taza', servingConversions: { 'cuarto taza': 40, taza: 160, cucharada: 10, '100g': 100 } },
  { id: 'cer-11', name: 'Fideos Cocidos', category: 'Granos y Cereales', calories: 131, protein: 4.5, carbs: 25.0, fat: 0.9, fiber: 1.8, defaultServing: 140, servingUnit: 'taza', servingConversions: { taza: 140, 'media taza': 70, '100g': 100 } },
  { id: 'cer-12', name: 'Macarrones Cocidos', category: 'Granos y Cereales', calories: 131, protein: 4.5, carbs: 25.0, fat: 0.9, fiber: 1.8, defaultServing: 140, servingUnit: 'taza', servingConversions: { taza: 140, 'media taza': 70, '100g': 100 } },
  { id: 'cer-13', name: 'Galleta Integral', category: 'Granos y Cereales', calories: 408, protein: 10.0, carbs: 68.0, fat: 12.0, fiber: 5.0, defaultServing: 30, servingUnit: '3 galletas', servingConversions: { galleta: 10, '3 galletas': 30, '100g': 100 } },
  { id: 'cer-14', name: 'Tostada de Pan', category: 'Granos y Cereales', calories: 313, protein: 11.0, carbs: 58.0, fat: 4.0, fiber: 3.5, defaultServing: 30, servingUnit: 'rebanada', servingConversions: { rebanada: 30, '100g': 100 } },
  { id: 'cer-15', name: 'Maíz Cancha (Tostado)', category: 'Granos y Cereales', calories: 415, protein: 10.5, carbs: 80.0, fat: 5.5, fiber: 7.0, defaultServing: 30, servingUnit: 'puñado', servingConversions: { puñado: 30, taza: 120, cucharada: 8, '100g': 100 } },
  { id: 'cer-16', name: 'Choclo Desgranado Cocido', category: 'Granos y Cereales', calories: 96, protein: 3.4, carbs: 21.0, fat: 1.2, fiber: 2.4, defaultServing: 154, servingUnit: 'taza', servingConversions: { taza: 154, mazorca: 90, '100g': 100 } },
  { id: 'cer-17', name: 'Mote Cocido', category: 'Granos y Cereales', calories: 119, protein: 3.5, carbs: 26.0, fat: 0.8, fiber: 2.8, defaultServing: 140, servingUnit: 'taza', servingConversions: { taza: 140, 'media taza': 70, '100g': 100 } },
  { id: 'cer-18', name: 'Cereal de Desayuno (Corn Flakes)', category: 'Granos y Cereales', calories: 357, protein: 7.5, carbs: 84.0, fat: 0.4, fiber: 2.0, defaultServing: 30, servingUnit: 'taza', servingConversions: { taza: 30, 'media taza': 15, cucharada: 4, '100g': 100 } },
  { id: 'cer-19', name: 'Granola', category: 'Granos y Cereales', calories: 471, protein: 10.0, carbs: 64.0, fat: 20.0, fiber: 6.5, defaultServing: 60, servingUnit: 'taza', servingConversions: { taza: 60, 'media taza': 30, cucharada: 8, '100g': 100 } },
  { id: 'cer-20', name: 'Hojuelas de Avena', category: 'Granos y Cereales', calories: 389, protein: 17.0, carbs: 66.0, fat: 7.0, fiber: 10.6, defaultServing: 40, servingUnit: 'media taza', servingConversions: { 'media taza': 40, taza: 80, cucharada: 10, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // LEGUMBRES Y MENESTRAS
  // ══════════════════════════════════════════════════════════════════
  { id: 'leg-1', name: 'Frijol Canario Cocido', category: 'Legumbres', calories: 143, protein: 9.0, carbs: 25.5, fat: 0.5, fiber: 6.4, defaultServing: 172, servingUnit: 'taza', servingConversions: { taza: 172, 'media taza': 86, cucharada: 11, '100g': 100 } },
  { id: 'leg-2', name: 'Frijol Negro Cocido', category: 'Legumbres', calories: 132, protein: 8.9, carbs: 23.7, fat: 0.5, fiber: 8.7, defaultServing: 172, servingUnit: 'taza', servingConversions: { taza: 172, 'media taza': 86, cucharada: 11, '100g': 100 } },
  { id: 'leg-3', name: 'Frijol Rojo Cocido', category: 'Legumbres', calories: 127, protein: 8.7, carbs: 22.8, fat: 0.5, fiber: 7.4, defaultServing: 172, servingUnit: 'taza', servingConversions: { taza: 172, 'media taza': 86, cucharada: 11, '100g': 100 } },
  { id: 'leg-4', name: 'Lenteja Cocida', category: 'Legumbres', calories: 116, protein: 9.0, carbs: 20.1, fat: 0.4, fiber: 7.9, defaultServing: 198, servingUnit: 'taza', servingConversions: { taza: 198, 'media taza': 99, cucharada: 12, '100g': 100 } },
  { id: 'leg-5', name: 'Garbanzo Cocido', category: 'Legumbres', calories: 164, protein: 8.9, carbs: 27.4, fat: 2.6, fiber: 7.6, defaultServing: 164, servingUnit: 'taza', servingConversions: { taza: 164, 'media taza': 82, cucharada: 10, '100g': 100 } },
  { id: 'leg-6', name: 'Arveja Verde Cocida', category: 'Legumbres', calories: 84, protein: 5.4, carbs: 15.6, fat: 0.2, fiber: 5.5, defaultServing: 160, servingUnit: 'taza', servingConversions: { taza: 160, 'media taza': 80, cucharada: 10, '100g': 100 } },
  { id: 'leg-7', name: 'Habas Cocidas', category: 'Legumbres', calories: 110, protein: 7.6, carbs: 19.7, fat: 0.4, fiber: 5.4, defaultServing: 170, servingUnit: 'taza', servingConversions: { taza: 170, 'media taza': 85, '100g': 100 } },
  { id: 'leg-8', name: 'Pallares Cocidos', category: 'Legumbres', calories: 115, protein: 7.8, carbs: 20.9, fat: 0.4, fiber: 5.0, defaultServing: 170, servingUnit: 'taza', servingConversions: { taza: 170, 'media taza': 85, '100g': 100 } },
  { id: 'leg-9', name: 'Soya Cocida', category: 'Legumbres', calories: 173, protein: 16.6, carbs: 9.9, fat: 9.0, fiber: 6.0, defaultServing: 172, servingUnit: 'taza', servingConversions: { taza: 172, 'media taza': 86, cucharada: 11, '100g': 100 } },
  { id: 'leg-10', name: 'Maní (Cacahuate) Tostado', category: 'Legumbres', calories: 585, protein: 23.7, carbs: 21.5, fat: 49.7, fiber: 8.5, defaultServing: 28, servingUnit: 'puñado', servingConversions: { puñado: 28, taza: 146, cucharada: 9, '100g': 100 } },
  { id: 'leg-11', name: 'Maní Crudo', category: 'Legumbres', calories: 567, protein: 25.8, carbs: 16.1, fat: 49.2, fiber: 8.5, defaultServing: 28, servingUnit: 'puñado', servingConversions: { puñado: 28, taza: 146, cucharada: 9, '100g': 100 } },
  { id: 'leg-12', name: 'Frijol de Palo Cocido', category: 'Legumbres', calories: 116, protein: 6.8, carbs: 20.7, fat: 0.4, fiber: 6.7, defaultServing: 172, servingUnit: 'taza', servingConversions: { taza: 172, 'media taza': 86, cucharada: 11, '100g': 100 } },
  { id: 'leg-13', name: 'Chocho (Tarwi) Cocido', category: 'Legumbres', calories: 151, protein: 15.0, carbs: 9.5, fat: 8.0, fiber: 7.5, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 170, cucharada: 11, '100g': 100 } },
  { id: 'leg-14', name: 'Arveja Seca Cocida', category: 'Legumbres', calories: 118, protein: 8.3, carbs: 21.1, fat: 0.4, fiber: 8.3, defaultServing: 196, servingUnit: 'taza', servingConversions: { taza: 196, 'media taza': 98, '100g': 100 } },
  { id: 'leg-15', name: 'Tofu', category: 'Legumbres', calories: 76, protein: 8.1, carbs: 1.9, fat: 4.8, fiber: 0.3, defaultServing: 85, servingUnit: 'porción', servingConversions: { porción: 85, taza: 248, cucharada: 16, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // FRUTOS PERUANAS ADICIONALES
  // ══════════════════════════════════════════════════════════════════
  { id: 'frut-pe-1', name: 'Lúcuma', category: 'Frutas', calories: 99, protein: 1.5, carbs: 24.0, fat: 0.5, fiber: 2.4, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, unidad: 200, cucharada: 15, '100g': 100 } },
  { id: 'frut-pe-2', name: 'Chirimoya', category: 'Frutas', calories: 75, protein: 1.6, carbs: 17.7, fat: 0.6, fiber: 3.0, defaultServing: 160, servingUnit: 'porción', servingConversions: { porción: 160, unidad: 300, '100g': 100 } },
  { id: 'frut-pe-3', name: 'Guanábana', category: 'Frutas', calories: 66, protein: 1.0, carbs: 16.8, fat: 0.3, fiber: 3.3, defaultServing: 200, servingUnit: 'porción', servingConversions: { porción: 200, taza: 225, '100g': 100 } },
  { id: 'frut-pe-4', name: 'Maracuyá', category: 'Frutas', calories: 97, protein: 2.2, carbs: 23.4, fat: 0.7, fiber: 10.4, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, unidad: 35, taza: 236, '100g': 100 } },
  { id: 'frut-pe-5', name: 'Camu Camu', category: 'Frutas', calories: 17, protein: 0.4, carbs: 4.0, fat: 0.1, fiber: 0.6, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 150, '100g': 100 } },
  { id: 'frut-pe-6', name: 'Aguaje', category: 'Frutas', calories: 283, protein: 2.5, carbs: 14.0, fat: 26.0, fiber: 5.0, defaultServing: 50, servingUnit: 'porción', servingConversions: { porción: 50, unidad: 30, '100g': 100 } },
  { id: 'frut-pe-7', name: 'Cocona', category: 'Frutas', calories: 27, protein: 0.9, carbs: 6.0, fat: 0.2, fiber: 1.5, defaultServing: 100, servingUnit: 'unidad', servingConversions: { unidad: 100, taza: 100, '100g': 100 } },
  { id: 'frut-pe-8', name: 'Carambola', category: 'Frutas', calories: 31, protein: 1.5, carbs: 6.7, fat: 0.3, fiber: 2.8, defaultServing: 91, servingUnit: 'unidad', servingConversions: { unidad: 91, taza: 108, '100g': 100 } },
  { id: 'frut-pe-9', name: 'Tumbo (Curuba)', category: 'Frutas', calories: 53, protein: 1.5, carbs: 12.0, fat: 0.4, fiber: 2.5, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },
  { id: 'frut-pe-10', name: 'Granadilla', category: 'Frutas', calories: 68, protein: 1.5, carbs: 15.5, fat: 0.3, fiber: 1.9, defaultServing: 100, servingUnit: 'unidad', servingConversions: { unidad: 100, taza: 100, '100g': 100 } },
  { id: 'frut-pe-11', name: 'Tuna (Higo Chumbo)', category: 'Frutas', calories: 41, protein: 0.7, carbs: 9.6, fat: 0.5, fiber: 3.6, defaultServing: 103, servingUnit: 'unidad', servingConversions: { unidad: 103, taza: 149, '100g': 100 } },
  { id: 'frut-pe-12', name: 'Guayaba', category: 'Frutas', calories: 68, protein: 2.6, carbs: 14.3, fat: 1.0, fiber: 5.4, defaultServing: 90, servingUnit: 'unidad', servingConversions: { unidad: 90, taza: 165, '100g': 100 } },
  { id: 'frut-pe-13', name: 'Pacay (Guaba)', category: 'Frutas', calories: 73, protein: 1.5, carbs: 17.0, fat: 0.3, fiber: 3.5, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 100, '100g': 100 } },
  { id: 'frut-pe-14', name: 'Pepino Dulce', category: 'Frutas', calories: 29, protein: 0.6, carbs: 7.0, fat: 0.1, fiber: 1.5, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, unidad: 200, '100g': 100 } },
  { id: 'frut-pe-15', name: 'Tomate de Árbol', category: 'Frutas', calories: 31, protein: 1.5, carbs: 7.0, fat: 0.2, fiber: 1.8, defaultServing: 100, servingUnit: 'unidad', servingConversions: { unidad: 100, taza: 150, '100g': 100 } },
  { id: 'frut-pe-16', name: 'Palta (Aguacate)', category: 'Frutas', calories: 160, protein: 2.0, carbs: 8.5, fat: 14.7, fiber: 6.7, defaultServing: 150, servingUnit: 'unidad mediana', servingConversions: { unidad: 150, 'media unidad': 75, cucharada: 15, taza: 150, '100g': 100 } },
  { id: 'frut-pe-17', name: 'Plátano de Isla (Maduro)', category: 'Frutas', calories: 122, protein: 1.3, carbs: 31.0, fat: 0.4, fiber: 2.3, defaultServing: 118, servingUnit: 'unidad mediana', servingConversions: { unidad: 118, taza: 225, '100g': 100 } },
  { id: 'frut-pe-18', name: 'Plátano Verde (Bellaco)', category: 'Frutas', calories: 89, protein: 1.1, carbs: 23.0, fat: 0.4, fiber: 2.6, defaultServing: 118, servingUnit: 'unidad', servingConversions: { unidad: 118, taza: 225, '100g': 100 } },
  { id: 'frut-pe-19', name: 'Limón Peruano', category: 'Frutas', calories: 29, protein: 1.1, carbs: 9.3, fat: 0.3, fiber: 2.8, defaultServing: 58, servingUnit: 'unidad', servingConversions: { unidad: 58, cucharada: 15, '100g': 100 } },
  { id: 'frut-pe-20', name: 'Membrillo', category: 'Frutas', calories: 57, protein: 0.4, carbs: 15.3, fat: 0.1, fiber: 1.9, defaultServing: 92, servingUnit: 'unidad', servingConversions: { unidad: 92, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // VERDURAS PERUANAS ADICIONALES
  // ══════════════════════════════════════════════════════════════════
  { id: 'verd-pe-1', name: 'Huacatay', category: 'Verduras', calories: 28, protein: 2.5, carbs: 4.5, fat: 0.5, fiber: 3.0, defaultServing: 5, servingUnit: 'cucharada', servingConversions: { cucharada: 5, taza: 30, '100g': 100 } },
  { id: 'verd-pe-2', name: 'Paico', category: 'Verduras', calories: 32, protein: 3.0, carbs: 5.0, fat: 0.5, fiber: 3.5, defaultServing: 5, servingUnit: 'cucharada', servingConversions: { cucharada: 5, taza: 30, '100g': 100 } },
  { id: 'verd-pe-3', name: 'Muña', category: 'Verduras', calories: 30, protein: 2.8, carbs: 4.8, fat: 0.4, fiber: 4.0, defaultServing: 34, servingUnit: 'taza', servingConversions: { taza: 34, '100g': 100 } },
  { id: 'verd-pe-4', name: 'Berros', category: 'Verduras', calories: 11, protein: 2.3, carbs: 1.3, fat: 0.1, fiber: 0.5, defaultServing: 34, servingUnit: 'taza', servingConversions: { taza: 34, '100g': 100 } },
  { id: 'verd-pe-5', name: 'Nabo', category: 'Verduras', calories: 28, protein: 0.9, carbs: 6.4, fat: 0.1, fiber: 1.8, defaultServing: 130, servingUnit: 'unidad', servingConversions: { unidad: 130, taza: 130, '100g': 100 } },
  { id: 'verd-pe-6', name: 'Colinabo', category: 'Verduras', calories: 27, protein: 1.7, carbs: 6.2, fat: 0.1, fiber: 2.5, defaultServing: 135, servingUnit: 'unidad', servingConversions: { unidad: 135, taza: 135, '100g': 100 } },
  { id: 'verd-pe-7', name: 'Lechuga Romana', category: 'Verduras', calories: 17, protein: 1.2, carbs: 3.3, fat: 0.3, fiber: 2.1, defaultServing: 47, servingUnit: 'taza', servingConversions: { taza: 47, '100g': 100 } },
  { id: 'verd-pe-8', name: 'Col (Repollo) Crudo', category: 'Verduras', calories: 25, protein: 1.3, carbs: 5.8, fat: 0.1, fiber: 2.5, defaultServing: 89, servingUnit: 'taza', servingConversions: { taza: 89, '100g': 100 } },
  { id: 'verd-pe-9', name: 'Cebolla Roja', category: 'Verduras', calories: 40, protein: 1.1, carbs: 9.3, fat: 0.1, fiber: 1.7, defaultServing: 110, servingUnit: 'unidad', servingConversions: { unidad: 110, taza: 160, cucharada: 10, '100g': 100 } },
  { id: 'verd-pe-10', name: 'Ajo', category: 'Verduras', calories: 149, protein: 6.4, carbs: 33.1, fat: 0.5, fiber: 2.1, defaultServing: 3, servingUnit: 'diente', servingConversions: { diente: 3, cucharadita: 5, cucharada: 15, '100g': 100 } },
  { id: 'verd-pe-11', name: 'Jengibre', category: 'Verduras', calories: 80, protein: 1.8, carbs: 17.8, fat: 0.8, fiber: 2.0, defaultServing: 5, servingUnit: 'cucharadita', servingConversions: { cucharadita: 5, cucharada: 15, '100g': 100 } },
  { id: 'verd-pe-12', name: 'Pimiento Rojo', category: 'Verduras', calories: 31, protein: 1.0, carbs: 6.0, fat: 0.3, fiber: 2.1, defaultServing: 119, servingUnit: 'unidad', servingConversions: { unidad: 119, taza: 149, '100g': 100 } },
  { id: 'verd-pe-13', name: 'Pimiento Verde', category: 'Verduras', calories: 20, protein: 0.9, carbs: 4.6, fat: 0.2, fiber: 1.7, defaultServing: 119, servingUnit: 'unidad', servingConversions: { unidad: 119, taza: 149, '100g': 100 } },
  { id: 'verd-pe-14', name: 'Tomate Cherry', category: 'Verduras', calories: 18, protein: 0.9, carbs: 3.9, fat: 0.2, fiber: 1.2, defaultServing: 149, servingUnit: 'taza', servingConversions: { taza: 149, unidad: 17, '100g': 100 } },
  { id: 'verd-pe-15', name: 'Espinaca Cocida', category: 'Verduras', calories: 23, protein: 2.9, carbs: 3.6, fat: 0.4, fiber: 2.4, defaultServing: 180, servingUnit: 'taza', servingConversions: { taza: 180, 'media taza': 90, '100g': 100 } },
  { id: 'verd-pe-16', name: 'Brócoli Cocido', category: 'Verduras', calories: 35, protein: 2.4, carbs: 7.2, fat: 0.4, fiber: 3.3, defaultServing: 156, servingUnit: 'taza', servingConversions: { taza: 156, 'media taza': 78, '100g': 100 } },
  { id: 'verd-pe-17', name: 'Zapallo Loche', category: 'Verduras', calories: 30, protein: 1.2, carbs: 7.0, fat: 0.1, fiber: 1.5, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 116, '100g': 100 } },
  { id: 'verd-pe-18', name: 'Caigua', category: 'Verduras', calories: 18, protein: 0.8, carbs: 4.0, fat: 0.1, fiber: 1.8, defaultServing: 100, servingUnit: 'unidad', servingConversions: { unidad: 100, taza: 120, '100g': 100 } },
  { id: 'verd-pe-19', name: 'Yacón', category: 'Verduras', calories: 54, protein: 0.4, carbs: 13.0, fat: 0.1, fiber: 0.9, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, unidad: 200, '100g': 100 } },
  { id: 'verd-pe-20', name: 'Achira (Canna)', category: 'Verduras', calories: 98, protein: 0.4, carbs: 13.0, fat: 0.1, fiber: 0.9, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // CARNES Y AVES (adicionales)
  // ══════════════════════════════════════════════════════════════════
  { id: 'carne-1', name: 'Pollo a la Brasa (sin piel)', category: 'Proteínas', calories: 185, protein: 28.0, carbs: 0, fat: 8.0, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, pieza: 120, '100g': 100 } },
  { id: 'carne-2', name: 'Pollo a la Brasa (con piel)', category: 'Proteínas', calories: 239, protein: 27.0, carbs: 0, fat: 14.0, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, pieza: 120, '100g': 100 } },
  { id: 'carne-3', name: 'Carne de Cerdo (chuleta)', category: 'Proteínas', calories: 231, protein: 25.7, carbs: 0, fat: 14.0, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, chuleta: 130, '100g': 100 } },
  { id: 'carne-4', name: 'Lomo de Res', category: 'Proteínas', calories: 215, protein: 17.2, carbs: 0, fat: 20.0, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 230, '100g': 100 } },
  { id: 'carne-5', name: 'Costilla de Res', category: 'Proteínas', calories: 291, protein: 24.0, carbs: 0, fat: 21.0, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, costilla: 80, '100g': 100 } },
  { id: 'carne-6', name: 'Molida de Res (80/20)', category: 'Proteínas', calories: 254, protein: 17.2, carbs: 0, fat: 20.0, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 230, '100g': 100 } },
  { id: 'carne-7', name: 'Hígado de Pollo', category: 'Proteínas', calories: 119, protein: 16.9, carbs: 0.9, fat: 4.8, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },
  { id: 'carne-8', name: 'Riñón de Res', category: 'Proteínas', calories: 99, protein: 17.4, carbs: 0.3, fat: 3.1, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },
  { id: 'carne-9', name: 'Mondongo (Tripa de Res)', category: 'Proteínas', calories: 97, protein: 14.8, carbs: 0, fat: 4.2, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 140, '100g': 100 } },
  { id: 'carne-10', name: 'Anticucho (Corazón de Res)', category: 'Proteínas', calories: 112, protein: 17.7, carbs: 0.1, fat: 4.5, fiber: 0, defaultServing: 80, servingUnit: 'palito', servingConversions: { palito: 80, '100g': 100 } },
  { id: 'carne-11', name: 'Pato', category: 'Proteínas', calories: 337, protein: 19.0, carbs: 0, fat: 28.4, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, pieza: 150, '100g': 100 } },
  { id: 'carne-12', name: 'Conejo', category: 'Proteínas', calories: 121, protein: 22.0, carbs: 0, fat: 3.5, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, filete: 150, '100g': 100 } },
  { id: 'carne-13', name: 'Llama (Carne)', category: 'Proteínas', calories: 121, protein: 22.0, carbs: 0, fat: 3.5, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, filete: 150, '100g': 100 } },
  { id: 'carne-14', name: 'Cecina (Carne Seca)', category: 'Proteínas', calories: 280, protein: 45.0, carbs: 0, fat: 10.5, fiber: 0, defaultServing: 50, servingUnit: 'porción', servingConversions: { porción: 50, '100g': 100 } },
  { id: 'carne-15', name: 'Chorizo Peruano', category: 'Proteínas', calories: 350, protein: 15.0, carbs: 2.0, fat: 31.0, fiber: 0, defaultServing: 60, servingUnit: 'unidad', servingConversions: { unidad: 60, '100g': 100 } },
  { id: 'carne-16', name: 'Jamón del País', category: 'Proteínas', calories: 245, protein: 18.0, carbs: 1.5, fat: 18.5, fiber: 0, defaultServing: 30, servingUnit: 'rebanada', servingConversions: { rebanada: 30, '100g': 100 } },
  { id: 'carne-17', name: 'Salchicha Frankfurt', category: 'Proteínas', calories: 290, protein: 12.0, carbs: 3.0, fat: 26.0, fiber: 0, defaultServing: 45, servingUnit: 'unidad', servingConversions: { unidad: 45, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // PESCADOS Y MARISCOS (adicionales)
  // ══════════════════════════════════════════════════════════════════
  { id: 'pesc-1', name: 'Ceviche de Pescado (preparado)', category: 'Proteínas', calories: 85, protein: 14.0, carbs: 4.5, fat: 1.5, fiber: 0.5, defaultServing: 200, servingUnit: 'porción', servingConversions: { porción: 200, '100g': 100 } },
  { id: 'pesc-2', name: 'Corvina', category: 'Proteínas', calories: 105, protein: 20.0, carbs: 0, fat: 2.5, fiber: 0, defaultServing: 150, servingUnit: 'filete', servingConversions: { filete: 150, porción: 100, '100g': 100 } },
  { id: 'pesc-3', name: 'Pejerrey', category: 'Proteínas', calories: 96, protein: 18.5, carbs: 0, fat: 2.2, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, unidad: 80, '100g': 100 } },
  { id: 'pesc-4', name: 'Merluza', category: 'Proteínas', calories: 86, protein: 17.8, carbs: 0, fat: 1.5, fiber: 0, defaultServing: 150, servingUnit: 'filete', servingConversions: { filete: 150, porción: 100, '100g': 100 } },
  { id: 'pesc-5', name: 'Perico (Dorado)', category: 'Proteínas', calories: 109, protein: 23.7, carbs: 0, fat: 1.0, fiber: 0, defaultServing: 150, servingUnit: 'filete', servingConversions: { filete: 150, porción: 100, '100g': 100 } },
  { id: 'pesc-6', name: 'Tollo (Cazón)', category: 'Proteínas', calories: 130, protein: 22.0, carbs: 0, fat: 4.5, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },
  { id: 'pesc-7', name: 'Anchoveta Fresca', category: 'Proteínas', calories: 131, protein: 20.4, carbs: 0, fat: 5.4, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, unidad: 15, '100g': 100 } },
  { id: 'pesc-8', name: 'Anchoveta en Conserva', category: 'Proteínas', calories: 210, protein: 29.0, carbs: 0, fat: 10.5, fiber: 0, defaultServing: 90, servingUnit: 'lata', servingConversions: { lata: 90, cucharada: 15, '100g': 100 } },
  { id: 'pesc-9', name: 'Atún en Agua (lata)', category: 'Proteínas', calories: 116, protein: 19.3, carbs: 0, fat: 1.0, fiber: 0, defaultServing: 85, servingUnit: 'lata', servingConversions: { lata: 85, cucharada: 15, '100g': 100 } },
  { id: 'pesc-10', name: 'Sardina en Tomate (lata)', category: 'Proteínas', calories: 162, protein: 19.3, carbs: 0, fat: 8.5, fiber: 0, defaultServing: 90, servingUnit: 'lata', servingConversions: { lata: 90, '100g': 100 } },
  { id: 'pesc-11', name: 'Cangrejo', category: 'Proteínas', calories: 97, protein: 19.4, carbs: 0, fat: 1.8, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 135, '100g': 100 } },
  { id: 'pesc-12', name: 'Erizo de Mar (Uni)', category: 'Proteínas', calories: 120, protein: 13.0, carbs: 3.4, fat: 5.8, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },
  { id: 'pesc-13', name: 'Macha (Almeja Peruana)', category: 'Proteínas', calories: 74, protein: 12.8, carbs: 3.2, fat: 1.0, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 128, '100g': 100 } },
  { id: 'pesc-14', name: 'Choro (Mejillón)', category: 'Proteínas', calories: 86, protein: 11.9, carbs: 2.2, fat: 2.2, fiber: 0, defaultServing: 150, servingUnit: 'taza', servingConversions: { taza: 150, porción: 100, '100g': 100 } },
  { id: 'pesc-15', name: 'Caracol de Mar', category: 'Proteínas', calories: 90, protein: 16.1, carbs: 5.1, fat: 0.4, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },
  { id: 'pesc-16', name: 'Paiche (Arapaima)', category: 'Proteínas', calories: 115, protein: 24.0, carbs: 0, fat: 2.0, fiber: 0, defaultServing: 150, servingUnit: 'filete', servingConversions: { filete: 150, porción: 100, '100g': 100 } },
  { id: 'pesc-17', name: 'Doncella (Pseudoplatystoma)', category: 'Proteínas', calories: 108, protein: 20.5, carbs: 0, fat: 2.8, fiber: 0, defaultServing: 150, servingUnit: 'filete', servingConversions: { filete: 150, porción: 100, '100g': 100 } },
  { id: 'pesc-18', name: 'Gamitana', category: 'Proteínas', calories: 120, protein: 21.0, carbs: 0, fat: 3.5, fiber: 0, defaultServing: 150, servingUnit: 'filete', servingConversions: { filete: 150, porción: 100, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // LÁCTEOS Y DERIVADOS (adicionales)
  // ══════════════════════════════════════════════════════════════════
  { id: 'lact-1', name: 'Leche Evaporada Entera', category: 'Lácteos', calories: 134, protein: 6.8, carbs: 10.0, fat: 7.9, fiber: 0, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, 'media taza': 120, taza: 240, '100g': 100 } },
  { id: 'lact-2', name: 'Leche Condensada', category: 'Lácteos', calories: 321, protein: 7.9, carbs: 54.4, fat: 8.7, fiber: 0, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, taza: 306, '100g': 100 } },
  { id: 'lact-3', name: 'Queso Fresco Peruano', category: 'Lácteos', calories: 264, protein: 18.0, carbs: 2.5, fat: 20.5, fiber: 0, defaultServing: 30, servingUnit: 'rebanada', servingConversions: { rebanada: 30, taza: 132, cucharada: 8, '100g': 100 } },
  { id: 'lact-4', name: 'Queso Andino', category: 'Lácteos', calories: 380, protein: 24.0, carbs: 1.5, fat: 31.0, fiber: 0, defaultServing: 30, servingUnit: 'rebanada', servingConversions: { rebanada: 30, taza: 132, cucharada: 8, '100g': 100 } },
  { id: 'lact-5', name: 'Queso Mozzarella', category: 'Lácteos', calories: 280, protein: 22.0, carbs: 2.2, fat: 22.0, fiber: 0, defaultServing: 28, servingUnit: 'rebanada', servingConversions: { rebanada: 28, taza: 112, cucharada: 7, '100g': 100 } },
  { id: 'lact-6', name: 'Mantequilla', category: 'Lácteos', calories: 717, protein: 0.9, carbs: 0.1, fat: 81.1, fiber: 0, defaultServing: 13, servingUnit: 'cucharada', servingConversions: { cucharada: 13, cucharadita: 4, '100g': 100 } },
  { id: 'lact-7', name: 'Crema de Leche', category: 'Lácteos', calories: 340, protein: 2.1, carbs: 2.8, fat: 36.1, fiber: 0, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, taza: 238, '100g': 100 } },
  { id: 'lact-8', name: 'Yogur de Frutas', category: 'Lácteos', calories: 99, protein: 3.5, carbs: 19.0, fat: 1.2, fiber: 0.1, defaultServing: 170, servingUnit: 'vaso', servingConversions: { vaso: 170, taza: 245, cucharada: 15, '100g': 100 } },
  { id: 'lact-9', name: 'Leche de Soya', category: 'Lácteos', calories: 54, protein: 3.3, carbs: 6.3, fat: 1.8, fiber: 0.5, defaultServing: 240, servingUnit: 'taza', servingConversions: { taza: 240, 'media taza': 120, cucharada: 15, '100g': 100 } },
  { id: 'lact-10', name: 'Helado de Vainilla', category: 'Lácteos', calories: 207, protein: 3.5, carbs: 23.6, fat: 11.0, fiber: 0.7, defaultServing: 66, servingUnit: 'bola', servingConversions: { bola: 66, taza: 132, cucharada: 17, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // GRASAS, ACEITES Y SEMILLAS
  // ══════════════════════════════════════════════════════════════════
  { id: 'grasa-1', name: 'Aceite de Oliva', category: 'Grasas y Aceites', calories: 884, protein: 0, carbs: 0, fat: 100, fiber: 0, defaultServing: 14, servingUnit: 'cucharada', servingConversions: { cucharada: 14, cucharadita: 5, taza: 216, '100g': 100 } },
  { id: 'grasa-2', name: 'Aceite de Girasol', category: 'Grasas y Aceites', calories: 884, protein: 0, carbs: 0, fat: 100, fiber: 0, defaultServing: 14, servingUnit: 'cucharada', servingConversions: { cucharada: 14, cucharadita: 5, taza: 216, '100g': 100 } },
  { id: 'grasa-3', name: 'Aceite de Soya', category: 'Grasas y Aceites', calories: 884, protein: 0, carbs: 0, fat: 100, fiber: 0, defaultServing: 14, servingUnit: 'cucharada', servingConversions: { cucharada: 14, cucharadita: 5, taza: 216, '100g': 100 } },
  { id: 'grasa-4', name: 'Aceite de Palma', category: 'Grasas y Aceites', calories: 884, protein: 0, carbs: 0, fat: 100, fiber: 0, defaultServing: 14, servingUnit: 'cucharada', servingConversions: { cucharada: 14, cucharadita: 5, '100g': 100 } },
  { id: 'grasa-5', name: 'Margarina', category: 'Grasas y Aceites', calories: 717, protein: 0.2, carbs: 0.7, fat: 80.5, fiber: 0, defaultServing: 13, servingUnit: 'cucharada', servingConversions: { cucharada: 13, cucharadita: 4, '100g': 100 } },
  { id: 'grasa-6', name: 'Manteca de Cerdo', category: 'Grasas y Aceites', calories: 902, protein: 0, carbs: 0, fat: 100, fiber: 0, defaultServing: 13, servingUnit: 'cucharada', servingConversions: { cucharada: 13, cucharadita: 4, '100g': 100 } },
  { id: 'grasa-7', name: 'Semillas de Chía', category: 'Grasas y Aceites', calories: 486, protein: 16.5, carbs: 42.1, fat: 30.7, fiber: 34.4, defaultServing: 28, servingUnit: '2 cucharadas', servingConversions: { '2 cucharadas': 28, cucharada: 14, taza: 160, '100g': 100 } },
  { id: 'grasa-8', name: 'Semillas de Lino', category: 'Grasas y Aceites', calories: 534, protein: 18.3, carbs: 28.9, fat: 42.2, fiber: 27.3, defaultServing: 14, servingUnit: 'cucharada', servingConversions: { cucharada: 14, taza: 149, '100g': 100 } },
  { id: 'grasa-9', name: 'Semillas de Girasol', category: 'Grasas y Aceites', calories: 584, protein: 20.8, carbs: 20.0, fat: 51.5, fiber: 8.6, defaultServing: 28, servingUnit: 'puñado', servingConversions: { puñado: 28, taza: 140, cucharada: 9, '100g': 100 } },
  { id: 'grasa-10', name: 'Semillas de Calabaza', category: 'Grasas y Aceites', calories: 559, protein: 30.2, carbs: 10.7, fat: 49.1, fiber: 6.0, defaultServing: 28, servingUnit: 'puñado', servingConversions: { puñado: 28, taza: 129, cucharada: 9, '100g': 100 } },
  { id: 'grasa-11', name: 'Nueces', category: 'Grasas y Aceites', calories: 654, protein: 15.2, carbs: 13.7, fat: 65.2, fiber: 6.7, defaultServing: 28, servingUnit: 'puñado', servingConversions: { puñado: 28, taza: 117, cucharada: 7, '100g': 100 } },
  { id: 'grasa-12', name: 'Almendras', category: 'Grasas y Aceites', calories: 579, protein: 21.2, carbs: 21.6, fat: 49.9, fiber: 12.5, defaultServing: 28, servingUnit: 'puñado', servingConversions: { puñado: 28, taza: 143, cucharada: 9, '100g': 100 } },
  { id: 'grasa-13', name: 'Pecanas (Nueces Pecán)', category: 'Grasas y Aceites', calories: 691, protein: 9.2, carbs: 13.9, fat: 72.0, fiber: 9.6, defaultServing: 28, servingUnit: 'puñado', servingConversions: { puñado: 28, taza: 109, cucharada: 7, '100g': 100 } },
  { id: 'grasa-14', name: 'Mantequilla de Maní', category: 'Grasas y Aceites', calories: 588, protein: 25.1, carbs: 20.1, fat: 50.4, fiber: 6.0, defaultServing: 32, servingUnit: '2 cucharadas', servingConversions: { '2 cucharadas': 32, cucharada: 16, taza: 258, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // AZÚCARES, DULCES Y CONFITERÍA
  // ══════════════════════════════════════════════════════════════════
  { id: 'azuc-1', name: 'Azúcar Blanca', category: 'Azúcares y Dulces', calories: 387, protein: 0, carbs: 100, fat: 0, fiber: 0, defaultServing: 12, servingUnit: 'cucharada', servingConversions: { cucharada: 12, cucharadita: 4, taza: 200, '100g': 100 } },
  { id: 'azuc-2', name: 'Azúcar Rubia (Morena)', category: 'Azúcares y Dulces', calories: 380, protein: 0, carbs: 98.1, fat: 0, fiber: 0, defaultServing: 12, servingUnit: 'cucharada', servingConversions: { cucharada: 12, cucharadita: 4, taza: 220, '100g': 100 } },
  { id: 'azuc-3', name: 'Chancaca (Panela)', category: 'Azúcares y Dulces', calories: 383, protein: 0.3, carbs: 98.0, fat: 0, fiber: 0, defaultServing: 12, servingUnit: 'cucharada', servingConversions: { cucharada: 12, cucharadita: 4, taza: 200, '100g': 100 } },
  { id: 'azuc-4', name: 'Miel de Abeja', category: 'Azúcares y Dulces', calories: 304, protein: 0.3, carbs: 82.4, fat: 0, fiber: 0.2, defaultServing: 21, servingUnit: 'cucharada', servingConversions: { cucharada: 21, cucharadita: 7, taza: 339, '100g': 100 } },
  { id: 'azuc-5', name: 'Mermelada de Frutas', category: 'Azúcares y Dulces', calories: 278, protein: 0.4, carbs: 68.9, fat: 0.1, fiber: 1.0, defaultServing: 20, servingUnit: 'cucharada', servingConversions: { cucharada: 20, cucharadita: 7, '100g': 100 } },
  { id: 'azuc-6', name: 'Chocolate Negro (70%)', category: 'Azúcares y Dulces', calories: 598, protein: 7.8, carbs: 45.9, fat: 42.6, fiber: 10.9, defaultServing: 28, servingUnit: 'porción', servingConversions: { porción: 28, cuadrito: 10, '100g': 100 } },
  { id: 'azuc-7', name: 'Chocolate con Leche', category: 'Azúcares y Dulces', calories: 535, protein: 7.7, carbs: 59.4, fat: 29.7, fiber: 3.4, defaultServing: 28, servingUnit: 'porción', servingConversions: { porción: 28, cuadrito: 10, '100g': 100 } },
  { id: 'azuc-8', name: 'Manjar Blanco (Dulce de Leche)', category: 'Azúcares y Dulces', calories: 328, protein: 6.8, carbs: 55.4, fat: 9.0, fiber: 0, defaultServing: 20, servingUnit: 'cucharada', servingConversions: { cucharada: 20, cucharadita: 7, '100g': 100 } },
  { id: 'azuc-9', name: 'Caramelo', category: 'Azúcares y Dulces', calories: 394, protein: 0.1, carbs: 98.0, fat: 0.1, fiber: 0, defaultServing: 10, servingUnit: 'unidad', servingConversions: { unidad: 10, '100g': 100 } },
  { id: 'azuc-10', name: 'Mazamorra Morada (preparada)', category: 'Azúcares y Dulces', calories: 95, protein: 0.5, carbs: 23.5, fat: 0.2, fiber: 0.8, defaultServing: 200, servingUnit: 'taza', servingConversions: { taza: 200, 'media taza': 100, '100g': 100 } },
  { id: 'azuc-11', name: 'Arroz con Leche (preparado)', category: 'Azúcares y Dulces', calories: 130, protein: 3.5, carbs: 22.0, fat: 3.5, fiber: 0.2, defaultServing: 200, servingUnit: 'taza', servingConversions: { taza: 200, 'media taza': 100, '100g': 100 } },
  { id: 'azuc-12', name: 'Suspiro Limeño', category: 'Azúcares y Dulces', calories: 285, protein: 4.5, carbs: 48.0, fat: 8.5, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },
  { id: 'azuc-13', name: 'Picarones (sin miel)', category: 'Azúcares y Dulces', calories: 290, protein: 4.5, carbs: 42.0, fat: 12.5, fiber: 1.5, defaultServing: 60, servingUnit: 'unidad', servingConversions: { unidad: 60, '100g': 100 } },
  { id: 'azuc-14', name: 'Turrones de Doña Pepa', category: 'Azúcares y Dulces', calories: 380, protein: 4.0, carbs: 65.0, fat: 12.0, fiber: 1.0, defaultServing: 50, servingUnit: 'porción', servingConversions: { porción: 50, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // BEBIDAS
  // ══════════════════════════════════════════════════════════════════
  { id: 'beb-1', name: 'Chicha Morada (preparada)', category: 'Bebidas', calories: 55, protein: 0.2, carbs: 14.0, fat: 0, fiber: 0.1, defaultServing: 240, servingUnit: 'vaso', servingConversions: { vaso: 240, taza: 240, '100g': 100 } },
  { id: 'beb-2', name: 'Chicha de Jora', category: 'Bebidas', calories: 40, protein: 0.5, carbs: 8.5, fat: 0.2, fiber: 0, defaultServing: 240, servingUnit: 'vaso', servingConversions: { vaso: 240, taza: 240, '100g': 100 } },
  { id: 'beb-3', name: 'Emoliente', category: 'Bebidas', calories: 35, protein: 0.3, carbs: 8.5, fat: 0.1, fiber: 0.5, defaultServing: 240, servingUnit: 'vaso', servingConversions: { vaso: 240, taza: 240, '100g': 100 } },
  { id: 'beb-4', name: 'Refresco de Maracuyá', category: 'Bebidas', calories: 45, protein: 0.3, carbs: 11.0, fat: 0.1, fiber: 0.2, defaultServing: 240, servingUnit: 'vaso', servingConversions: { vaso: 240, taza: 240, '100g': 100 } },
  { id: 'beb-5', name: 'Jugo de Naranja Natural', category: 'Bebidas', calories: 45, protein: 0.7, carbs: 10.4, fat: 0.2, fiber: 0.2, defaultServing: 240, servingUnit: 'vaso', servingConversions: { vaso: 240, taza: 240, '100g': 100 } },
  { id: 'beb-6', name: 'Jugo de Piña', category: 'Bebidas', calories: 53, protein: 0.4, carbs: 12.9, fat: 0.1, fiber: 0.2, defaultServing: 240, servingUnit: 'vaso', servingConversions: { vaso: 240, taza: 240, '100g': 100 } },
  { id: 'beb-7', name: 'Leche Chocolatada', category: 'Bebidas', calories: 83, protein: 3.4, carbs: 11.5, fat: 2.5, fiber: 0.3, defaultServing: 240, servingUnit: 'vaso', servingConversions: { vaso: 240, taza: 240, '100g': 100 } },
  { id: 'beb-8', name: 'Café Negro', category: 'Bebidas', calories: 2, protein: 0.3, carbs: 0, fat: 0, fiber: 0, defaultServing: 240, servingUnit: 'taza', servingConversions: { taza: 240, 'media taza': 120, '100g': 100 } },
  { id: 'beb-9', name: 'Té de Hierbas', category: 'Bebidas', calories: 1, protein: 0, carbs: 0.2, fat: 0, fiber: 0, defaultServing: 240, servingUnit: 'taza', servingConversions: { taza: 240, '100g': 100 } },
  { id: 'beb-10', name: 'Gaseosa (Cola)', category: 'Bebidas', calories: 41, protein: 0, carbs: 10.6, fat: 0, fiber: 0, defaultServing: 355, servingUnit: 'lata', servingConversions: { lata: 355, vaso: 240, '100g': 100 } },
  { id: 'beb-11', name: 'Agua Mineral', category: 'Bebidas', calories: 0, protein: 0, carbs: 0, fat: 0, fiber: 0, defaultServing: 500, servingUnit: 'botella', servingConversions: { botella: 500, vaso: 240, taza: 240, '100g': 100 } },
  { id: 'beb-12', name: 'Bebida Energizante', category: 'Bebidas', calories: 45, protein: 0, carbs: 11.3, fat: 0, fiber: 0, defaultServing: 250, servingUnit: 'lata', servingConversions: { lata: 250, vaso: 240, '100g': 100 } },
  { id: 'beb-13', name: 'Cerveza', category: 'Bebidas', calories: 43, protein: 0, carbs: 10.8, fat: 0, fiber: 0, defaultServing: 355, servingUnit: 'lata', servingConversions: { lata: 355, vaso: 240, '100g': 100 } },
  { id: 'beb-14', name: 'Pisco', category: 'Bebidas', calories: 250, protein: 0, carbs: 0, fat: 0, fiber: 0, defaultServing: 45, servingUnit: 'copa', servingConversions: { copa: 45, '100g': 100 } },
  { id: 'beb-15', name: 'Inca Kola', category: 'Bebidas', calories: 43, protein: 0, carbs: 10.8, fat: 0, fiber: 0, defaultServing: 355, servingUnit: 'lata', servingConversions: { lata: 355, vaso: 240, '100g': 100 } },
  { id: 'beb-16', name: 'Maca en Bebida', category: 'Bebidas', calories: 30, protein: 0.8, carbs: 6.5, fat: 0.2, fiber: 0.5, defaultServing: 240, servingUnit: 'vaso', servingConversions: { vaso: 240, taza: 240, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // COMIDAS PREPARADAS PERUANAS
  // ══════════════════════════════════════════════════════════════════
  { id: 'plato-1', name: 'Arroz con Pollo', category: 'Comidas Preparadas', calories: 148, protein: 9.5, carbs: 18.5, fat: 3.8, fiber: 1.0, defaultServing: 300, servingUnit: 'plato', servingConversions: { plato: 300, taza: 200, '100g': 100 } },
  { id: 'plato-2', name: 'Lomo Saltado', category: 'Comidas Preparadas', calories: 185, protein: 14.0, carbs: 12.0, fat: 9.5, fiber: 1.5, defaultServing: 300, servingUnit: 'plato', servingConversions: { plato: 300, porción: 200, '100g': 100 } },
  { id: 'plato-3', name: 'Ají de Gallina', category: 'Comidas Preparadas', calories: 175, protein: 12.0, carbs: 10.5, fat: 9.5, fiber: 1.0, defaultServing: 300, servingUnit: 'plato', servingConversions: { plato: 300, porción: 200, '100g': 100 } },
  { id: 'plato-4', name: 'Causa Limeña', category: 'Comidas Preparadas', calories: 155, protein: 6.5, carbs: 20.0, fat: 6.0, fiber: 1.5, defaultServing: 200, servingUnit: 'porción', servingConversions: { porción: 200, rebanada: 100, '100g': 100 } },
  { id: 'plato-5', name: 'Ceviche de Pescado', category: 'Comidas Preparadas', calories: 85, protein: 14.0, carbs: 4.5, fat: 1.5, fiber: 0.5, defaultServing: 250, servingUnit: 'plato', servingConversions: { plato: 250, porción: 150, '100g': 100 } },
  { id: 'plato-6', name: 'Sopa de Quinoa', category: 'Comidas Preparadas', calories: 65, protein: 3.5, carbs: 10.5, fat: 1.5, fiber: 1.5, defaultServing: 300, servingUnit: 'tazón', servingConversions: { tazón: 300, taza: 240, '100g': 100 } },
  { id: 'plato-7', name: 'Sancochado', category: 'Comidas Preparadas', calories: 95, protein: 7.5, carbs: 10.0, fat: 2.5, fiber: 2.0, defaultServing: 400, servingUnit: 'plato', servingConversions: { plato: 400, tazón: 300, '100g': 100 } },
  { id: 'plato-8', name: 'Caldo de Gallina', category: 'Comidas Preparadas', calories: 45, protein: 4.5, carbs: 3.5, fat: 1.5, fiber: 0.3, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },
  { id: 'plato-9', name: 'Tacu Tacu', category: 'Comidas Preparadas', calories: 195, protein: 7.5, carbs: 32.0, fat: 4.5, fiber: 4.5, defaultServing: 200, servingUnit: 'porción', servingConversions: { porción: 200, '100g': 100 } },
  { id: 'plato-10', name: 'Papaa la Huancaína', category: 'Comidas Preparadas', calories: 165, protein: 5.5, carbs: 18.5, fat: 8.0, fiber: 1.5, defaultServing: 200, servingUnit: 'porción', servingConversions: { porción: 200, plato: 300, '100g': 100 } },
  { id: 'plato-11', name: 'Rocoto Relleno', category: 'Comidas Preparadas', calories: 145, protein: 9.0, carbs: 10.5, fat: 7.5, fiber: 2.0, defaultServing: 200, servingUnit: 'unidad', servingConversions: { unidad: 200, '100g': 100 } },
  { id: 'plato-12', name: 'Pachamanca (mixta)', category: 'Comidas Preparadas', calories: 175, protein: 12.5, carbs: 15.0, fat: 7.0, fiber: 2.5, defaultServing: 350, servingUnit: 'plato', servingConversions: { plato: 350, porción: 200, '100g': 100 } },
  { id: 'plato-13', name: 'Chicharrón de Cerdo', category: 'Comidas Preparadas', calories: 544, protein: 30.0, carbs: 0, fat: 47.0, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 140, '100g': 100 } },
  { id: 'plato-14', name: 'Pollo a la Brasa (plato)', category: 'Comidas Preparadas', calories: 210, protein: 22.0, carbs: 2.0, fat: 13.0, fiber: 0, defaultServing: 250, servingUnit: 'porción', servingConversions: { porción: 250, 'cuarto pollo': 250, '100g': 100 } },
  { id: 'plato-15', name: 'Arroz Chaufa', category: 'Comidas Preparadas', calories: 165, protein: 7.5, carbs: 22.0, fat: 5.5, fiber: 1.0, defaultServing: 300, servingUnit: 'porción', servingConversions: { porción: 300, taza: 200, '100g': 100 } },
  { id: 'plato-16', name: 'Tallarin Saltado', category: 'Comidas Preparadas', calories: 155, protein: 8.0, carbs: 20.0, fat: 5.0, fiber: 1.5, defaultServing: 300, servingUnit: 'porción', servingConversions: { porción: 300, taza: 200, '100g': 100 } },
  { id: 'plato-17', name: 'Sopa a la Minuta', category: 'Comidas Preparadas', calories: 85, protein: 6.5, carbs: 9.5, fat: 2.5, fiber: 0.8, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },
  { id: 'plato-18', name: 'Estofado de Pollo', category: 'Comidas Preparadas', calories: 125, protein: 12.0, carbs: 8.5, fat: 5.0, fiber: 1.5, defaultServing: 300, servingUnit: 'porción', servingConversions: { porción: 300, taza: 200, '100g': 100 } },
  { id: 'plato-19', name: 'Sopa de Menestrón', category: 'Comidas Preparadas', calories: 75, protein: 4.5, carbs: 10.0, fat: 2.0, fiber: 2.5, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },
  { id: 'plato-20', name: 'Carapulcra', category: 'Comidas Preparadas', calories: 185, protein: 10.5, carbs: 22.0, fat: 6.5, fiber: 3.5, defaultServing: 300, servingUnit: 'porción', servingConversions: { porción: 300, '100g': 100 } },
  { id: 'plato-21', name: 'Pepián de Trigo', category: 'Comidas Preparadas', calories: 145, protein: 8.5, carbs: 18.5, fat: 4.5, fiber: 3.5, defaultServing: 300, servingUnit: 'porción', servingConversions: { porción: 300, '100g': 100 } },
  { id: 'plato-22', name: 'Sopa de Habas', category: 'Comidas Preparadas', calories: 70, protein: 4.5, carbs: 11.0, fat: 1.0, fiber: 3.5, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },
  { id: 'plato-23', name: 'Caldo de Cabeza', category: 'Comidas Preparadas', calories: 55, protein: 5.5, carbs: 4.0, fat: 1.5, fiber: 0.5, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },
  { id: 'plato-24', name: 'Juane de Arroz', category: 'Comidas Preparadas', calories: 175, protein: 9.5, carbs: 22.0, fat: 5.5, fiber: 1.0, defaultServing: 200, servingUnit: 'unidad', servingConversions: { unidad: 200, '100g': 100 } },
  { id: 'plato-25', name: 'Inchicapi (Sopa Amazónica)', category: 'Comidas Preparadas', calories: 95, protein: 7.5, carbs: 8.5, fat: 3.5, fiber: 1.5, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },
  { id: 'plato-26', name: 'Tacacho con Cecina', category: 'Comidas Preparadas', calories: 285, protein: 15.0, carbs: 32.0, fat: 11.0, fiber: 2.5, defaultServing: 300, servingUnit: 'porción', servingConversions: { porción: 300, '100g': 100 } },
  { id: 'plato-27', name: 'Patarashca', category: 'Comidas Preparadas', calories: 115, protein: 20.5, carbs: 2.0, fat: 3.0, fiber: 0.5, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },
  { id: 'plato-28', name: 'Cuy Chactado', category: 'Comidas Preparadas', calories: 245, protein: 28.0, carbs: 0, fat: 14.5, fiber: 0, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },
  { id: 'plato-29', name: 'Chancho al Palo', category: 'Comidas Preparadas', calories: 295, protein: 22.0, carbs: 0, fat: 22.5, fiber: 0, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },
  { id: 'plato-30', name: 'Sopa de Chupe de Camarones', category: 'Comidas Preparadas', calories: 110, protein: 9.5, carbs: 10.5, fat: 3.5, fiber: 1.0, defaultServing: 400, servingUnit: 'tazón', servingConversions: { tazón: 400, taza: 240, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // SNACKS Y COMIDA RÁPIDA
  // ══════════════════════════════════════════════════════════════════
  { id: 'snack-1', name: 'Papas Fritas (chips)', category: 'Snacks', calories: 536, protein: 7.0, carbs: 53.0, fat: 34.6, fiber: 4.8, defaultServing: 28, servingUnit: 'porción', servingConversions: { porción: 28, taza: 28, '100g': 100 } },
  { id: 'snack-2', name: 'Papas Fritas (bastones)', category: 'Snacks', calories: 312, protein: 3.4, carbs: 41.4, fat: 15.0, fiber: 3.8, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, taza: 150, '100g': 100 } },
  { id: 'snack-3', name: 'Chifles (Plátano Frito)', category: 'Snacks', calories: 490, protein: 2.5, carbs: 62.0, fat: 26.0, fiber: 3.5, defaultServing: 30, servingUnit: 'porción', servingConversions: { porción: 30, taza: 30, '100g': 100 } },
  { id: 'snack-4', name: 'Maíz Cancha Salado', category: 'Snacks', calories: 415, protein: 10.5, carbs: 80.0, fat: 5.5, fiber: 7.0, defaultServing: 30, servingUnit: 'puñado', servingConversions: { puñado: 30, taza: 120, cucharada: 8, '100g': 100 } },
  { id: 'snack-5', name: 'Galleta Dulce', category: 'Snacks', calories: 480, protein: 6.5, carbs: 68.0, fat: 20.0, fiber: 1.5, defaultServing: 30, servingUnit: '3 galletas', servingConversions: { galleta: 10, '3 galletas': 30, '100g': 100 } },
  { id: 'snack-6', name: 'Hamburguesa (casera)', category: 'Snacks', calories: 295, protein: 17.0, carbs: 24.0, fat: 13.5, fiber: 1.5, defaultServing: 150, servingUnit: 'unidad', servingConversions: { unidad: 150, '100g': 100 } },
  { id: 'snack-7', name: 'Pizza (porción)', category: 'Snacks', calories: 266, protein: 11.4, carbs: 33.0, fat: 10.4, fiber: 2.3, defaultServing: 107, servingUnit: 'rebanada', servingConversions: { rebanada: 107, '100g': 100 } },
  { id: 'snack-8', name: 'Empanada de Carne', category: 'Snacks', calories: 285, protein: 10.5, carbs: 30.0, fat: 14.0, fiber: 1.5, defaultServing: 100, servingUnit: 'unidad', servingConversions: { unidad: 100, '100g': 100 } },
  { id: 'snack-9', name: 'Tamale Peruano', category: 'Snacks', calories: 195, protein: 7.5, carbs: 28.0, fat: 6.5, fiber: 2.0, defaultServing: 150, servingUnit: 'unidad', servingConversions: { unidad: 150, '100g': 100 } },
  { id: 'snack-10', name: 'Pan con Chicharrón', category: 'Snacks', calories: 380, protein: 16.0, carbs: 35.0, fat: 19.0, fiber: 1.5, defaultServing: 150, servingUnit: 'unidad', servingConversions: { unidad: 150, '100g': 100 } },
  { id: 'snack-11', name: 'Buñuelo', category: 'Snacks', calories: 320, protein: 5.5, carbs: 42.0, fat: 15.0, fiber: 1.0, defaultServing: 60, servingUnit: 'unidad', servingConversions: { unidad: 60, '100g': 100 } },
  { id: 'snack-12', name: 'Tequeño', category: 'Snacks', calories: 350, protein: 10.5, carbs: 38.0, fat: 17.5, fiber: 0.5, defaultServing: 30, servingUnit: 'unidad', servingConversions: { unidad: 30, '100g': 100 } },
  { id: 'snack-13', name: 'Palomitas de Maíz', category: 'Snacks', calories: 387, protein: 12.9, carbs: 77.9, fat: 4.5, fiber: 14.5, defaultServing: 28, servingUnit: 'taza', servingConversions: { taza: 8, '3 tazas': 24, porción: 28, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // CONDIMENTOS Y SALSAS
  // ══════════════════════════════════════════════════════════════════
  { id: 'cond-1', name: 'Salsa de Ají Amarillo', category: 'Condimentos', calories: 35, protein: 1.0, carbs: 7.0, fat: 0.5, fiber: 1.5, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, cucharadita: 5, taza: 220, '100g': 100 } },
  { id: 'cond-2', name: 'Salsa Huancaína', category: 'Condimentos', calories: 185, protein: 5.5, carbs: 8.5, fat: 15.0, fiber: 0.5, defaultServing: 30, servingUnit: 'cucharada', servingConversions: { cucharada: 30, taza: 240, '100g': 100 } },
  { id: 'cond-3', name: 'Salsa de Rocoto', category: 'Condimentos', calories: 45, protein: 1.5, carbs: 9.0, fat: 0.5, fiber: 2.0, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, cucharadita: 5, taza: 220, '100g': 100 } },
  { id: 'cond-4', name: 'Salsa Criolla', category: 'Condimentos', calories: 25, protein: 0.5, carbs: 5.5, fat: 0.2, fiber: 1.0, defaultServing: 50, servingUnit: 'porción', servingConversions: { porción: 50, cucharada: 15, '100g': 100 } },
  { id: 'cond-5', name: 'Mayonesa', category: 'Condimentos', calories: 680, protein: 1.0, carbs: 0.6, fat: 75.0, fiber: 0, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, cucharadita: 5, taza: 220, '100g': 100 } },
  { id: 'cond-6', name: 'Ketchup', category: 'Condimentos', calories: 112, protein: 1.7, carbs: 27.0, fat: 0.1, fiber: 0.3, defaultServing: 17, servingUnit: 'cucharada', servingConversions: { cucharada: 17, cucharadita: 6, taza: 272, '100g': 100 } },
  { id: 'cond-7', name: 'Mostaza', category: 'Condimentos', calories: 66, protein: 4.4, carbs: 5.8, fat: 3.3, fiber: 3.3, defaultServing: 5, servingUnit: 'cucharadita', servingConversions: { cucharadita: 5, cucharada: 15, '100g': 100 } },
  { id: 'cond-8', name: 'Salsa de Soya', category: 'Condimentos', calories: 53, protein: 8.1, carbs: 4.9, fat: 0.1, fiber: 0.8, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, cucharadita: 5, taza: 272, '100g': 100 } },
  { id: 'cond-9', name: 'Vinagre', category: 'Condimentos', calories: 18, protein: 0, carbs: 0.9, fat: 0, fiber: 0, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, cucharadita: 5, taza: 272, '100g': 100 } },
  { id: 'cond-10', name: 'Sal', category: 'Condimentos', calories: 0, protein: 0, carbs: 0, fat: 0, fiber: 0, defaultServing: 6, servingUnit: 'cucharadita', servingConversions: { cucharadita: 6, cucharada: 18, '100g': 100 } },
  { id: 'cond-11', name: 'Pasta de Ají Panca', category: 'Condimentos', calories: 55, protein: 2.0, carbs: 11.0, fat: 0.8, fiber: 3.5, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, cucharadita: 5, taza: 272, '100g': 100 } },
  { id: 'cond-12', name: 'Pasta de Ají Mirasol', category: 'Condimentos', calories: 50, protein: 1.8, carbs: 10.0, fat: 0.7, fiber: 3.0, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, cucharadita: 5, taza: 272, '100g': 100 } },
  { id: 'cond-13', name: 'Aderezo de Limón y Aceite', category: 'Condimentos', calories: 120, protein: 0.1, carbs: 1.5, fat: 13.0, fiber: 0, defaultServing: 15, servingUnit: 'cucharada', servingConversions: { cucharada: 15, cucharadita: 5, taza: 272, '100g': 100 } },

  // ══════════════════════════════════════════════════════════════════
  // HUEVOS Y DERIVADOS
  // ══════════════════════════════════════════════════════════════════
  { id: 'huevo-1', name: 'Huevo de Gallina Cocido', category: 'Proteínas', calories: 155, protein: 13.0, carbs: 1.1, fat: 10.6, fiber: 0, defaultServing: 50, servingUnit: 'unidad', servingConversions: { unidad: 50, '100g': 100 } },
  { id: 'huevo-2', name: 'Huevo Frito', category: 'Proteínas', calories: 196, protein: 13.6, carbs: 0.4, fat: 15.4, fiber: 0, defaultServing: 46, servingUnit: 'unidad', servingConversions: { unidad: 46, '100g': 100 } },
  { id: 'huevo-3', name: 'Huevo Revuelto', category: 'Proteínas', calories: 149, protein: 10.1, carbs: 1.6, fat: 11.5, fiber: 0, defaultServing: 61, servingUnit: 'porción', servingConversions: { porción: 61, '100g': 100 } },
  { id: 'huevo-4', name: 'Huevo de Codorniz', category: 'Proteínas', calories: 158, protein: 13.1, carbs: 0.4, fat: 11.1, fiber: 0, defaultServing: 9, servingUnit: 'unidad', servingConversions: { unidad: 9, '5 unidades': 45, '100g': 100 } },
  { id: 'huevo-5', name: 'Tortilla de Huevo', category: 'Proteínas', calories: 154, protein: 10.6, carbs: 1.6, fat: 11.7, fiber: 0, defaultServing: 100, servingUnit: 'porción', servingConversions: { porción: 100, '100g': 100 } },
  { id: 'super-1', name: 'Spirulina en Polvo', category: 'Superalimentos', calories: 290, protein: 57.5, carbs: 23.9, fat: 7.7, fiber: 3.6, defaultServing: 7, servingUnit: 'cucharadita', servingConversions: { cucharadita: 7, cucharada: 21, '100g': 100 } },
  { id: 'super-2', name: 'Cacao en Polvo (sin azúcar)', category: 'Superalimentos', calories: 228, protein: 19.6, carbs: 57.9, fat: 13.7, fiber: 37.0, defaultServing: 5, servingUnit: 'cucharadita', servingConversions: { cucharadita: 5, cucharada: 15, taza: 86, '100g': 100 } },
  { id: 'super-3', name: 'Cacao Nibs', category: 'Superalimentos', calories: 480, protein: 27.0, carbs: 12.0, fat: 49.0, fiber: 18.0, defaultServing: 28, servingUnit: 'porción', servingConversions: { porción: 28, cucharada: 9, taza: 140, '100g': 100 } },
  { id: 'super-4', name: 'Maca en Cápsulas (equiv.)', category: 'Superalimentos', calories: 325, protein: 10.2, carbs: 65.0, fat: 2.2, fiber: 8.5, defaultServing: 3, servingUnit: 'cápsula', servingConversions: { cápsula: 3, cucharadita: 5, '100g': 100 } },
  { id: 'super-5', name: 'Sacha Inchi (semilla)', category: 'Superalimentos', calories: 566, protein: 27.0, carbs: 12.0, fat: 49.0, fiber: 18.0, defaultServing: 28, servingUnit: 'puñado', servingConversions: { puñado: 28, cucharada: 9, taza: 140, '100g': 100 } },
  { id: 'super-6', name: 'Aceite de Sacha Inchi', category: 'Superalimentos', calories: 884, protein: 0, carbs: 0, fat: 100, fiber: 0, defaultServing: 14, servingUnit: 'cucharada', servingConversions: { cucharada: 14, cucharadita: 5, '100g': 100 } },
  { id: 'super-7', name: 'Camu Camu en Polvo', category: 'Superalimentos', calories: 25, protein: 0.5, carbs: 6.0, fat: 0.1, fiber: 0.8, defaultServing: 5, servingUnit: 'cucharadita', servingConversions: { cucharadita: 5, cucharada: 15, '100g': 100 } },
  { id: 'super-8', name: 'Quinoa en Hojuelas', category: 'Superalimentos', calories: 368, protein: 14.1, carbs: 64.2, fat: 6.1, fiber: 7.0, defaultServing: 40, servingUnit: 'media taza', servingConversions: { 'media taza': 40, taza: 80, cucharada: 10, '100g': 100 } },
  { id: 'super-9', name: 'Lucuma en Polvo', category: 'Superalimentos', calories: 329, protein: 4.0, carbs: 80.0, fat: 2.4, fiber: 11.5, defaultServing: 10, servingUnit: 'cucharada', servingConversions: { cucharada: 10, cucharadita: 4, '100g': 100 } },
  { id: 'super-10', name: 'Yacon en Polvo', category: 'Superalimentos', calories: 220, protein: 2.5, carbs: 55.0, fat: 0.5, fiber: 6.0, defaultServing: 10, servingUnit: 'cucharada', servingConversions: { cucharada: 10, cucharadita: 4, '100g': 100 } },
  { id: 'proc-1', name: 'Fideos Instantaneos (sopas)', category: 'Granos y Cereales', calories: 436, protein: 9.5, carbs: 63.0, fat: 17.0, fiber: 2.5, defaultServing: 75, servingUnit: 'paquete', servingConversions: { paquete: 75, '100g': 100 } },
  { id: 'proc-2', name: 'Avena Instantanea', category: 'Granos y Cereales', calories: 379, protein: 13.5, carbs: 68.0, fat: 6.5, fiber: 9.5, defaultServing: 40, servingUnit: 'sobre', servingConversions: { sobre: 40, taza: 80, cucharada: 10, '100g': 100 } },
  { id: 'proc-3', name: 'Leche en Polvo Entera', category: 'Lacteos', calories: 496, protein: 26.3, carbs: 38.4, fat: 26.7, fiber: 0, defaultServing: 25, servingUnit: '4 cucharadas', servingConversions: { '4 cucharadas': 25, cucharada: 6, taza: 128, '100g': 100 } },
  { id: 'proc-4x', name: 'Leche en Polvo Descremada Extra', category: 'Lacteos', calories: 362, protein: 36.2, carbs: 52.0, fat: 0.8, fiber: 0, defaultServing: 25, servingUnit: '4 cucharadas', servingConversions: { '4 cucharadas': 25, cucharada: 6, '100g': 100 } },
];

foodDatabase?.push(...minsaExtendedFoods);

export const getCategories = () => {
  const categories = [...new Set(foodDatabase.map(food => food.category))];
  return ['Todas', ...categories?.sort()];
};

export const searchFoods = (query, category = 'Todas') => {
  let filtered = foodDatabase;
  if (category !== 'Todas') {
    filtered = filtered?.filter(food => food?.category === category);
  }
  if (query) {
    filtered = filtered?.filter(food =>
      food?.name?.toLowerCase()?.includes(query?.toLowerCase())
    );
  }
  return filtered;
};

export const calculateNutrition = (food, grams) => {
  const multiplier = grams / 100;
  return {
    calories: Math.round(food?.calories * multiplier),
    protein: Math.round(food?.protein * multiplier * 10) / 10,
    carbs: Math.round(food?.carbs * multiplier * 10) / 10,
    fat: Math.round(food?.fat * multiplier * 10) / 10,
    fiber: Math.round((food?.fiber || 0) * multiplier * 10) / 10
  };
};

export const getServingOptions = (food) => {
  if (food?.servingConversions) {
    return Object.entries(food?.servingConversions)?.filter(([key]) => key !== '100g')?.map(([label, grams]) => ({ label, grams }));
  }
  return [{ label: food?.servingUnit || '100g', grams: food?.defaultServing || 100 }];
};

export default foodDatabase;
